(function (w) {
  "use strict";

  Cnvs.Frames = {
    // Add new frame to gallery
    addFrame(imgURL, file) {
      return (
        Cnvs?.Errors?.safe(
          () => {
            cLog("🖼️ Cnvs.Frames: Adding new frame with image:" + imgURL);
            cLog("🖼️ Cnvs.Frames: Adding new frame with file:" + file);

            // Validate input
            if (!imgURL || typeof imgURL !== "string")
              throw new Error("Invalid image URL provided");

            const state = Cnvs?.State?.getState() || {};
            const size = state?.selectedSize;
            const style = state?.selectedStyle;
            const style4Search = style === 'None' ? 'Wrapped_Canvas' : style;

            const frameData = Cnvs.Utils.findPByKey(`${style4Search}__${size.variant}`);

            if (!frameData || !frameData.price) {
              console.error(`❌ Could not find pricing for frame: ${frameID}`);
              Cnvs?.State?.setError("frame", `Pricing not found for ${frameID}`);
              return null;
            }

            // Add frame to centralized state
            const frame = {
              id: Cnvs?.State?.generateFrameId(),
              style: style,
              edge: state?.selectedEdge ? state?.selectedEdge : "Wrapped",
              size: {
                variant: size.variant,
                size: size.size,
                width: size.width,
                height: size.height,
              },
              acrylic: state?.withAcrylic,
              bw: state?.withBW || false,
              price: frameData.price,
              variantID: frameData.id,
              positionIndex: state.frames?.length || 0,
              cssStyles: {
                height: "200px", // Default height
                width: "160px", // Default width
                borderWidth: "2px", // Default border width
                padding: "0px", // Default padding (mat border)
              },
              image: {
                file: file,
                previewURL: imgURL,
                filestackUrl: null,
                status: "pending",
                crop: "",
                visableCrop: "",
                scale: "",
                imgStyles: "",
                manualChange: "false",
                minScale: "false",
              },
            };
            // Create frame HTML
            const frameHTML = this.frameHTML(frame);

            // Insert frame into DOM
            const imgPreview = S$G("img-preview");
            if (!imgPreview) {
              console.error("❌ Image preview container not found");
              Cnvs?.State?.setError("frame", "Preview container not found");
              return null;
            }

            imgPreview.insertAdjacentHTML("beforeend", frameHTML);
            const frameElement = imgPreview.lastElementChild;

            if (!frameElement) {
              console.error("❌ Failed to create frame element");
              Cnvs?.State?.setError("frame", "Failed to create frame element");
              return null;
            }

            // Add to state manager (check for duplicates)
            const existingFrame = Cnvs?.State?.getFrame(frame.id);
            if (!existingFrame) {
              const addedFrame = Cnvs?.State?.addFrame(frame);
              if (!addedFrame && Cnvs?.State) {
                console.error("❌ Failed to add frame to state");
                frameElement.remove();
                return null;
              }
            } else {
              cLog(
                "ℹ️ Frame already exists in state, skipping duplicate addition"
              );
            }

            // Set up remove button event listener with state management
            const removeButton = frameElement.querySelector(".dp_rb");
            if (removeButton) {
              removeButton.addEventListener("click", () =>
                this.handleFrameRemoval(frame.id, frameElement)
              );
            }

            // Update computed state
            Cnvs?.State?.updateComputed();

            cLog(`✅ Frame added successfully: ${frame.id}`);

            // Return the image element for further processing
            return frameElement.querySelector("img");
          },
          "Cnvs.Frames.addFrame",
          null
        ) || null
      );
    },

    // Handle frame removal
    handleFrameRemoval(stateFrameId, frameElement) {
      try {
        cLog(`🗑️ Removing frame: ${stateFrameId}`);

        // Remove from DOM
        frameElement.remove();

        // Remove from state
        Cnvs?.State?.removeFrame(stateFrameId);

        // Update frame indices and UI
        this.setFID();
        this.updateFrameSizes("size");

        // Auto-save to database
        setTimeout(() => {
          Cnvs?.State?.scheduleSave();
        }, 200);

        // Disable Add to Cart if no frames left
        if (S$$(".framefh").length === 0) {
          const atcBtn = S$Q(".dp_st__atc-btn");
          if (atcBtn) {
            atcBtn.classList.add("disa");
          }
        }

        cLog("✅ Frame removed successfully");
      } catch (removeError) {
        console.error("❌ Error removing frame:", removeError);
        Cnvs?.State?.setError("frame", "Failed to remove frame");
      }
    },

    // Update Frame Index
    setFID() {
      cLog("🔢 Cnvs.Frames: Updating frame indices and state");

      try {
        // Get DOM frames
        const frames = S$$(".frame");
        let indexedCount = 0;
        let stateUpdated = false;

        // Access the current frame data from state
        const stateFrames = w.Cnvs?.State?.data?.frames;

        if (!Array.isArray(stateFrames)) {
          console.warn("⚠️ Cnvs.State.data.frames is undefined or not an array");
          return;
        }

        frames.forEach((frameElement, domIndex) => {
          try {
            frameElement.dataset.frameIndex = domIndex;
            const frameId = frameElement.dataset.frameId;

            if (!frameId) {
              console.warn(
                `⚠️ Frame at DOM index ${domIndex} missing frame ID`
              );
              return;
            }

            const frameIndex = stateFrames.findIndex((f) => f.id === frameId);

            if (frameIndex === -1) {
              console.warn(
                `⚠️ Frame ${frameId} found in DOM but not in Cnvs.State.data.frames`
              );
              return;
            }

            const frame = stateFrames[frameIndex];
            // Only update if positionIndex has changed
            if (frame.positionIndex !== domIndex) {
              Cnvs?.State?.updateFrame(frameId, { positionIndex: domIndex });
              stateUpdated = true;
            }

            indexedCount++;
          } catch (frameError) {
            console.error(`❌ Error indexing frame ${domIndex}:`, frameError);
          }
        });

        // If any state was changed, normalize indices
        if (stateUpdated) {
          Cnvs?.State?.reindexFrames();
        }

        // Multi-frame flag in MainContent
        const mainContent = S$G("MainContent");
        if (mainContent) {
          mainContent.dataset.fa = frames.length > 1;
        }

        // Update derived/computed data
        Cnvs?.State?.updateComputed();

        // Optional summary UI update
        if (typeof w.Cnvs.Cart?.buildFramesSummary === "function") {
          w.Cnvs.Cart?.buildFramesSummary();
        }

        cLog(
          `✅ Indexed ${indexedCount} frames, multi-frame: ${frames.length > 1}`
        );

        // Check DOM/state mismatch
        if (stateFrames.length !== frames.length) {
          console.warn(
            `⚠️ State/DOM mismatch: ${stateFrames.length} in state, ${frames.length} in DOM`
          );
          Cnvs?.State?.setError(
            "indexing",
            "Frame count mismatch between state and DOM"
          );
        } else {
          cLog(`📊 State consistency: ${frames.length} frames`);
        }

        Cnvs?.State?.triggerUpdate("frameIndexing");
      } catch (error) {
        console.error("❌ Error in Cnvs.Frames.setFID:", error);
        Cnvs?.State?.setError("indexing", error.message);
      }
    },

    // ================================================================
    // FRAME SIZING FUNCTIONS (EXTRACTED)
    // ================================================================
    // Private timer for debouncing
    _updateFrameSizesTimer: null,

    // Update Frame Sizes PX (debounced)
    updateFrameSizes(action, i2s) {
      clearTimeout(this._updateFrameSizesTimer);
      this._updateFrameSizesTimer = setTimeout(() => {
        this._updateFrameSizesImmediate(action, i2s);
      }, 500);
    },

    // Update Frame Sizes PX immediately
     async _updateFrameSizesImmediate(action, i2s) {
      cLog(`📐 Cnvs.Frames: Updating frame sizes - Action: ${action}, i2s: ${i2s}`);

      try {
        // Update loading state
        Cnvs?.State?.updateLoading("frames", true);

        // Handle AESnP (Apply Edit Settings new Position) if needed
        if (i2s) {
          this.AESnP();
        }

        // Get frames and validate
        const frames = S$$(".frame");
        if (frames.length === 0) {
          cLog("ℹ️ No frames to update");
          Cnvs?.State?.updateLoading("frames", false);
          return;
        }

        let dpGHeight = 350;
        // Get the height of the ".dp_row" element
        if (w.dType === "M") {
          if(w.Cnvs.Main?.ui?.galHeight){
            dpGHeight = w.Cnvs.Main.ui.galHeight;
          } else {
            const elHeight = selector => S$Q(selector)?.offsetHeight || 0;
            dpGHeight = window.innerHeight - ['.pfp-h_banner', 'header.header', '.dp_sidebar', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
          }
        }


        // Calculate maximum dimensions
        const { maxFrameHeight, maxFrameWidth } = this.getWstAndTstFrameD(frames);
        const { maxHeight, maxWidth } = w.dType === "M" ? { maxHeight: dpGHeight * 0.7, maxWidth: w.innerWidth * 0.7 } : { maxHeight: 400, maxWidth: 400 };

        cLog(`📱 Device type: ${w.dType}, Max dimensions: ${maxWidth}x${maxHeight}`);

        // Calculate scaling ratios
        const hr = maxFrameHeight / maxHeight;
        const wr = maxFrameWidth / maxWidth;
        const a2c = hr > wr ? "h" : "w";

        cLog(`📊 Scaling ratios - Height: ${hr.toFixed(3)}, Width: ${wr.toFixed(3)}, Adjust by: ${a2c}`);

        // Update each frame with error handling
        let updatedCount = 0;
        let errorCount = 0;
        const updatePromises = [];
        frames.forEach((frame, index) => {
          try {
            const updatePromise = this.updateFrameSize(frame, maxFrameHeight, maxHeight, maxFrameWidth, maxWidth, a2c, action, i2s);
            
            updatePromises.push(updatePromise);
            updatedCount++;
          } catch (frameError) {
            console.error(`❌ Error updating frame ${index}:`, frameError);
            errorCount++;
          }
        });
        
        // Wait for all frames to finish updating in parallel
        await Promise.all(updatePromises);
        
        cLog(`✅ Updated ${updatedCount} frames, ${errorCount} errors`);

        // NOW update state AFTER styles have been applied
        frames.forEach((frame) => {
            const frameId = frame.dataset.frameId;
            if (frameId && w.appState?.frames?.find((f) => f.id === frameId)) {
              // Frame sizing info could be stored in state if needed
              Cnvs?.State?.updateFrame(frameId, {
                lastSizeUpdate: Date.now(),
                scalingRatio: a2c === "h" ? hr : wr,
              });
            }

            if (frameId && action === "first" && w.Cnvs.State.data.frames?.find((f) => f.id === frameId)) {
              const padding = parseFloat(frame?.style?.padding ?? "0") || 0;
              const img = frame?.querySelector(".img-box img");
              const scale = Cnvs.Utils.getScale?.(img) || 1;
              const newBorderPx = Math.round(padding / scale || 0);

              frame.dataset.borderPx = newBorderPx;

              Cnvs?.State?.updateFrame?.(frameId, { borderPx: newBorderPx });
            }
          requestAnimationFrame(() => {
            frame.style.scale = "1";
            // frame.style.visibility = "visible";
            frame.style.opacity = "1";
            frame.style.pointerEvents = "auto";
            const container = frame.closest(".frame_container");
            if (container) container.classList.add("frame_container-visible");
          });
        });
        cLog(`✅ Updated ${updatedCount} frames, ${errorCount} errors`);

        // Handle mobile swiper
        if (w.dType === "M") {
          setTimeout(() => {
            this.handleSwiper(frames);
          }, 100);
        }

        // Set up event listeners for first load or page load
        if (action === "first" || action === "PageLoad") {
          this.setupFrameEventListeners();
        }

        // Enable Add to Cart button on first load
        if (action === "first") {
          setTimeout(() => {
            cLog("🛒 Enabling Add to Cart button");
            const atcBtn = document.querySelector(".dp_st__atc-btn");
            if (atcBtn) {
              atcBtn.classList.remove("disa");
            }
          }, 500);
        }

        // Auto-save to database (skip for page load to avoid conflicts)
        if (action !== "PageLoad") {
          setTimeout(() => {
            Cnvs?.State?.scheduleSave();
          }, 300); // Debounced save
        }

        // Update computed state and check PPI
        Cnvs?.State?.updateComputed();
        setTimeout(() => {this.checkPPI();}, 300);

        // Update loading state
        Cnvs?.State?.updateLoading("frames", false);

        // Trigger state update
        Cnvs?.State?.triggerUpdate("frameResize");
      } catch (error) {
        console.error("❌ Error in Cnvs.Frames.updateFrameSizes:", error);
        Cnvs?.State?.setError("frameResize", error.message);
        Cnvs?.State?.updateLoading("frames", false);
      }
    },

    // Helper function to set up frame event listeners
    setupFrameEventListeners() {
      cLog("🎯 Cnvs.Frames: Setting up frame event listeners");

      try {
        // Edit button listeners
        S$$(".dp_eb").forEach((b) =>
          b.addEventListener("click", w.editpu || this.editpu.bind(this))
        );

        S$$(".dp_rb").forEach((r) => {
          r.addEventListener("click", (event) => {
            event.stopPropagation();
            cLog("🗑️ Remove frame clicked");
            this.handleFrameRemoval(r.closest(".frame").dataset.frameId, r.closest(".frame_container"))
          });
        });

        // Frame click listeners
        document.querySelectorAll(".framefh").forEach((frame) => {
          frame.addEventListener("click", (event) => {
            if (event.target.closest(".dp_eb, .dp_cb, .dp_rb, .dp_lr")) {
              event.stopPropagation();
              return;
            }
            (w.editpu || this.editpu.bind(this))(event);
          });
        });

        // Low resolution warning listeners
        document.querySelectorAll(".dp_lr").forEach((dplr) => {
          dplr.addEventListener("click", function (event) {
            event.stopPropagation();
            cLog("📷 Low resolution warning clicked");
          });
        });

        // Crop button listeners
        document.querySelectorAll(".dp_cb").forEach((c) => {
          c.addEventListener("click", w.editpu || this.editpu.bind(this))
        });

        cLog("✅ Frame event listeners set up successfully");
      } catch (error) {
        console.error("❌ Error setting up frame event listeners:", error);
      }
    },

    // Check PPI for all frames
    checkPPI() {
      const PPIObject = { PPI: [] };
      S$$(".framefh").forEach((frame) => {
        const frameSizeW = frame.dataset.widthInInches;
        const frameSizeH = frame.dataset.heightInInches;
        const ceB = frame.querySelector(".img-box");
        const ceI = frame.querySelector(".img-box img");
        const ceSc = Cnvs?.Utils?.getScale
          ? Cnvs.Utils.getScale(ceB.querySelector("img"))
          : 1;
        const ceNW = ceI.naturalWidth;
        const paperDiagonalInches = Math.sqrt(
          frameSizeW ** 2 + frameSizeH ** 2
        );
        const imageDiagonal = Math.sqrt(
          (parseFloat(w.getComputedStyle(ceB).width) * (1 / ceSc)) ** 2 +
          (parseFloat(w.getComputedStyle(ceB).height) * (1 / ceSc)) ** 2
        );
        const currentPPI = imageDiagonal / paperDiagonalInches;
        PPIObject.PPI.push(currentPPI);
        if (currentPPI <= 70) {
          frame.classList.add("low-ppi");
        } else {
          frame.classList.remove("low-ppi");
        }
      });
      console.groupCollapsed("PPI Per Frame:");
      console.table(PPIObject);
      console.groupEnd();
    },

    // ================================================================
    // FRAME DIMENSION & STYLING FUNCTIONS (EXTRACTED)
    // ================================================================

    // Update all frames to new dimensions
    updateAllFramesInches(newWidth, newHeight) {
      cLog(`🔄 Cnvs.Frames: Updating all frames to size: ${newWidth}x${newHeight}`);

      // Update centralized state first
      Cnvs?.State?.updateSelectedSize(newWidth, newHeight);

      // Get all DOM frame containers
      const frameContainers = S$$(".frame_container");

      document.body.offsetHeight;
      frameContainers.forEach((frameContainer, index) => {
        const frameElement = frameContainer.querySelector(".frame");
        if (!frameElement) return;

        // Get current frame style for price lookup
        const frameStyle = frameElement.dataset.frameStyle || w.appState?.selectedStyle;
        const style4Search = frameStyle === 'None' ? 'Wrapped_Canvas' : frameStyle;

        // Calculate product ID for price lookup
        const sortedSize =
          parseInt(newWidth) < parseInt(newHeight)
            ? `${style4Search}__${newWidth}x${newHeight}`
            : `${style4Search}__${newHeight}x${newWidth}`;

        const frameData = Cnvs.Utils.findPByKey(sortedSize);
        if (!frameData) {
          console.warn(`❌ No frame data found for: ${sortedSize}`);
          return;
        }

        const newPrice = frameData.price;
        const newVariantID = frameData.id;

        // Update DOM attributes (for backward compatibility)
        frameElement.dataset.vid = newVariantID;
        frameElement.dataset.widthInInches = newWidth;
        frameElement.dataset.heightInInches = newHeight;

        // Update price display
        const priceElement = frameContainer.querySelector(".finfo_price");
        if (priceElement) {
          priceElement.innerText = `$${newPrice}`;
        }

        // If we have frames in state, update them too
        if (Cnvs?.State?.data?.frames?.length > index) {
          Cnvs?.State?.updateFrame(Cnvs.State.data.frames[index].id, {
            size: {
              variant:
                newWidth < newHeight
                  ? newWidth + "x" + newHeight
                  : newHeight + "x" + newWidth,
              size: newWidth + "x" + newHeight,
              width: newWidth,
              height: newHeight,
            },
            price: newPrice,
            variantID: newVariantID,
          });
        }
      });

      // Trigger related updates
      this._updateFrameSizesImmediate("shape");
      if (typeof w.Cnvs.Cart?.buildFramesSummary === "function") {
        w.Cnvs.Cart?.buildFramesSummary();
      }

      // Auto-save to database
      if (w.appState?.frames?.length > 0) {
        setTimeout(() => {
          Cnvs?.State?.scheduleSave();
        }, 500); // Debounced save
      }

      cLog(
        `✅ Updated ${frameContainers.length} frames to ${newWidth}x${newHeight}`
      );
    },

    // ================================================================
    // FRAME STYLING FUNCTIONS (EXTRACTED)
    // ================================================================

    // Update all frames to a new style
    updateAllFramesStyles(style) {
      cLog(`🎨 Cnvs.Frames: Updating all frames to style: ${style}`);

      const errors = Cnvs?.Errors;

      return (
        errors?.safe(
          () => {
            // Validate inputs
            if (!style || typeof style !== "string") {
              throw new Error("Invalid style name provided");
            }

            // Update centralized state first
            Cnvs?.State?.updateSelectedStyle(style);

            // Update all existing frames
            const frames = document.querySelectorAll(".frame");
            let updatedCount = 0;

            frames.forEach((frame, index) => {
              try {
                // Get current frame dimensions
                const state = Cnvs?.State?.getState() || {};
                const width =
                  frame.dataset.widthInInches ||
                  state.selectedSize?.width ||
                  w.gwIncs ||
                  8;
                const height =
                  frame.dataset.heightInInches ||
                  state.selectedSize?.height ||
                  w.ghIncs ||
                  10;

                if (!width || !height) {
                  console.warn(
                    `⚠️ Frame ${index} missing size data, using defaults`
                  );
                  return;
                }
                const style4Search = style === 'None' ? 'Wrapped_Canvas' : style;
                // Calculate new product ID for price/variant lookup
                const sortedSize =
                  parseInt(width) < parseInt(height)
                    ? `${style4Search}__${width}x${height}`
                    : `${style4Search}__${height}x${width}`;

                // Get frame data using global function
                const frameData = Cnvs.Utils.findPByKey(sortedSize);
                if (!frameData) {
                  console.warn(
                    `❌ No frame data found for style: ${sortedSize}`
                  );
                  return;
                }

                // Update DOM attributes
                frame.dataset.vid = frameData.id;
                frame.dataset.frameStyle = style;

                // Update price if there's a price element
                const frameContainer = frame.closest(".frame_container");
                const priceElement =
                  frameContainer?.querySelector(".finfo_price");
                if (priceElement) {
                  priceElement.innerText = `$${frameData.price}`;
                }

                // Update state if frame exists in our collection
                const frameState = Cnvs?.State?.getState() || {};
                if (frameState.frames?.length > index) {
                  Cnvs?.State?.updateFrame(frameState.frames[index].id, {
                    style: style,
                    price: frameData.price,
                    variantID: frameData.id,
                  });
                }

                updatedCount++;
              } catch (error) {
                console.error(`❌ Error updating frame ${index}:`, error);
              }
            });

            S$$(".dp_vp__size-box__item").forEach((sizeItem) => {
              const style4Search = style === 'None' ? 'Wrapped_Canvas' : style;
              const size = sizeItem.dataset.value.split('x');
              const sortedSize = parseInt(size[0]) < parseInt(size[1]) ? `${style4Search}__${size[0]}x${size[1]}` : `${style4Search}__${size[1]}x${size[0]}`;
              const frameData = Cnvs.Utils.findPByKey(sortedSize);
              sizeItem.querySelector("label:last-of-type").innerText = `$${frameData.price} Each`;
            });

            // Trigger related updates
            if(typeof this.updateFrameSizes === "function") {
              this._updateFrameSizesImmediate("styles");
            }
            if (typeof w.Cnvs.Cart?.buildFramesSummary === "function") {
              w.Cnvs.Cart?.buildFramesSummary();
            }

            // Auto-save to database (debounced)
            if (updatedCount > 0) {
              setTimeout(() => {
                Cnvs?.State?.scheduleSave();
              }, 500);
            }

            cLog(`✅ Updated ${updatedCount}/${frames.length} frames to style: ${style}`);

            // Trigger state change listeners
            Cnvs?.State?.triggerUpdate("frames");

            return updatedCount;
          },
          "Cnvs.Frames.updateAllFramesStyles",
          0
        ) || 0
      );
    },

    // Update all frames edge
    async updateAllFramesEdge(edge) {
      return (
        Cnvs?.Errors?.safe(async () => {
          if (!edge) cWarn("Missing edge");
          if (!edge || !Cnvs.State.FRAME_EDGES.includes(edge)) cWarn(`⚠️ Missing or Unknown edge type: ${edge}`);

          Cnvs?.State?.updateSelectedEdge(edge);

          const frameElements = document.querySelectorAll(".frame");
          let updatedCount = 0;
          const updatePromises = [];

          frameElements.forEach((frameEl, index) => {
            try {
              const img = frameEl.querySelector(".img-box img");
              if(!img) {
                  frameEl.dataset.frameEdge = edge;
                  return;
              }
              
              if(!img || edge === frameEl.dataset.frameEdge) return;
              const { scale } = this.getInlineTransformValues(img);
              const prevEdge = frameEl.dataset.frameEdge || "Wrapped";
              void frameEl.offsetHeight; 
              const {  ab, borderPx, newTop, newLeft, NEWceSc } = this.applyFrameBorderLogic(frameEl, edge, scale);
                // Collect the promise for parallel execution
              frameEl.dataset.frameEdge = edge;
              if (prevEdge === "Wrapped" || edge === "Wrapped") {
                const updatePromise = Cnvs.Frames.sizeAdjustPosition({frame: frameEl, Ra4Sc: 1, newLeft, newTop, newScale: NEWceSc});
                updatePromises.push(updatePromise);
              }          
              updatedCount++;
            } catch (err) {
              console.error(`❌ Error updating frame ${index}:`, err);
            }
          });

          // Wait for all frames to finish updating in parallel
          await Promise.all(updatePromises);

          // Update state AFTER all frames have been updated
          frameElements.forEach((frameEl, index) => {
            try {
                const frameId = frameEl.dataset.frameId;
                if (frameId && Cnvs?.State?.getState()?.frames?.length > 0) {
                  const img = frameEl.querySelector(".img-box img");
                  if(!img) return;
                  const ab = parseFloat(frameEl.style.padding) || 0;
                  const scale = parseFloat(img.dataset.scaleVal) || Cnvs.Utils.getScaleAndRotation?.(img)?.scale || 1;
                  const newBorderPx = Math.round(ab * (1 / scale));
                  if (frameId) Cnvs.State.updateFrame(frameId, {edge,borderPadding: ab,borderPx: newBorderPx});
                }
              } catch (err) {
                console.error(`❌ Error updating frame ${index}:`, err);
              }
          });

          w.Cnvs.Cart.buildFramesSummary();
          if (Cnvs?.State?.getState()?.frames?.length > 0) setTimeout(() => Cnvs?.State?.scheduleSave(), 500); // Debounced save
          cLog(`✅ Updated border for ${updatedCount} frames to: ${edge}`);

          return updatedCount;
        },
        "Cnvs.Frames.updateAllFramesBorder",
        0
        ) || 0
      );
    },

    // ================================================================
    // HELPER FUNCTIONS (EXTRACTED)
    // ================================================================

    // Get tallest frame dimensions
    getWstAndTstFrameD(frames) {
      let maxFrameHeight = 0;
      let maxFrameWidth = 0;
      frames.forEach((frame) => {
        const width = parseInt(frame.getAttribute("data-width-in-inches"), 10);
        const height = parseInt(
          frame.getAttribute("data-height-in-inches"),
          10
        );
        if (width > maxFrameWidth) {
          maxFrameWidth = width;
        }
        if (height > maxFrameHeight) {
          maxFrameHeight = height;
        }
      });
      return { maxFrameHeight, maxFrameWidth };
    },

    sidePixels(frontIn, frontPx, depthIn) {
      const p = frontPx / frontIn;                // px per inch על מישור הפרונט
      const depthPx = depthIn * p / 6;       
      return depthPx;
    },

    // Update individual frame size
    async updateFrameSize(
      frame,
      maxFrameHeight,
      maxHeight,
      maxFrameWidth,
      maxWidth,
      a2c,
      action,
      i2s
    ) {
      let oldBW, oldBH, oldWdiFC, oldHdiFC;
      
      if (frame.querySelectorAll(".img-box").length > 0) {
        const ceB = frame.dataset.frameEdge === "Wrapped" ? frame.querySelector(".img-print") : frame.querySelector(".img-box");
        var ceI = frame.querySelector(".img-box img");
        oldBW = ceB.clientWidth;
        oldBH = ceB.clientHeight;
        const natW = ceI.naturalWidth;
        const natH = ceI.naturalHeight;

        const CLeft = ceI.offsetLeft;
        const CTop = ceI.offsetTop;

        const elWCe = (natW - oldBW) / 2;
        const elHCe = (natH - oldBH) / 2;

        var bigLeft = -elWCe;
        var bigTop = -elHCe;

        oldWdiFC = CLeft - bigLeft;
        oldHdiFC = CTop - bigTop;
      }
      const borderInInches = 0.9;
      const widthInInches = parseInt(frame.getAttribute("data-width-in-inches"), 10);
      const heightInInches = parseInt(frame.getAttribute("data-height-in-inches"), 10);
      const heightRatio = heightInInches / maxFrameHeight;
      const widthRatio = widthInInches / maxFrameWidth;
      var Ra4Sc = heightRatio;
      const frameWidth = parseFloat(frame.style.width);
      if (a2c == "h") {
        var adjustedHeight = heightRatio * maxHeight;
        var adjustedWidth = (widthInInches / heightInInches) * adjustedHeight;
        if (adjustedWidth > maxWidth) {
          const widthRatio = maxWidth / adjustedWidth;
          adjustedWidth = maxWidth;
          adjustedHeight *= widthRatio;
        }
      } else {
        Ra4Sc = widthRatio;
        var adjustedWidth = widthRatio * maxWidth;
        var adjustedHeight = (heightInInches / widthInInches) * adjustedWidth;
        if (adjustedHeight > maxHeight) {
          const heightRatio = maxHeight / adjustedHeight;
          adjustedHeight = maxHeight;
          adjustedWidth *= heightRatio;
        }
      }

      const s4c = widthInInches > heightInInches ? heightInInches : widthInInches;
      var adjustedBorder = (borderInInches / heightInInches) * adjustedHeight;
      const PXwidthRatio = adjustedWidth / frameWidth;

      // ENABLE TRANSITIONS (remove no-transition class if present)
      frame.classList.remove('no-transition');
      if (frame.querySelector('.img-box img')) {
        frame.querySelector('.img-box img').classList.remove('no-transition');
      }

      let frameVars;
      if (frame.dataset.frameStyle === "None") {
        const sidePx = this.sidePixels(widthInInches, adjustedWidth, borderInInches);

        frameVars = {
          '--p-hinches': heightInInches,
          '--p-winches': widthInInches,
          '--w-height':  (adjustedHeight + sidePx) + "px",
          '--w-width':   (adjustedWidth + sidePx) + "px",
          '--b-height':  adjustedHeight + "px",
          '--b-width':   adjustedWidth + "px",
          adjustedBorder: 0,
        };
        adjustedBorder= 0;
      } else {
        frameVars = {
          '--p-hinches': heightInInches,
          '--p-winches': widthInInches,
          '--w-height':  adjustedHeight + "px",
          '--w-width':   adjustedWidth + "px",
          '--b-height':  adjustedHeight + "px",
          '--b-width':   adjustedWidth + "px",
          adjustedBorder: adjustedBorder + "px",
        };
      }
      // frame.style.borderWidth = `${adjustedBorder}px`;
      frame.style.setProperty('--frame-size', `${adjustedBorder}px`);
      const frameId = frame.dataset.frameId;
      // Update state's cssStyles when DOM styles change
      if (frameId) {
        this.updateFrameCssStyles(frameId, {
          height: `${adjustedHeight}px`,
          width: `${adjustedWidth}px`,
          borderWidth: `${adjustedBorder}px`,
        });
      }else{
        this.applyFrameProps(frame, frameVars);
        frame.style.height = `${adjustedHeight}px`;
        frame.style.width = `${adjustedWidth}px`;
        frame.style.borderWidth = `${adjustedBorder}px`;
      }
      
      if (frame.querySelector(".img-box")) {
         return await this.sizeAdjustPosition({
            frame,
            "Ra4Sc": PXwidthRatio,
            action,
            oldWdiFC,
            oldHdiFC,
            frameProps: frameVars
          });
      }
      return true;
    },

    getAdjustedPositionAfterScale(ife, previousScale, updatedScale) {
      const newScale = parseFloat(updatedScale) || parseFloat(Cnvs.Popup.current.ceScale);
      const oldScale = parseFloat(previousScale);

      const oldLeft = parseFloat(ife.style.left) || ife.offsetLeft;
      const oldTop = parseFloat(ife.style.top) || ife.offsetTop;

      const shrinkDueToNewScale = 1 - newScale;
      const newHalfWidthShrink = (ife.naturalWidth * shrinkDueToNewScale) / 2;
      const newHalfHeightShrink = (ife.naturalHeight * shrinkDueToNewScale) / 2;

      const shrinkDueToOldScale = 1 - oldScale;
      const oldHalfWidthShrink = (ife.naturalWidth * shrinkDueToOldScale) / 2;
      const oldHalfHeightShrink = (ife.naturalHeight * shrinkDueToOldScale) / 2;

      const oldTotalOffsetX = oldHalfWidthShrink + oldLeft;
      const oldTotalOffsetY = oldHalfHeightShrink + oldTop;

      const newTotalOffsetX = (oldTotalOffsetX / oldScale) * newScale;
      const newTotalOffsetY = (oldTotalOffsetY / oldScale) * newScale;

      const adjustedLeft = -newHalfWidthShrink + newTotalOffsetX;
      const adjustedTop = -newHalfHeightShrink + newTotalOffsetY;

      return {
        bigLeft: adjustedLeft,
        bigTop: adjustedTop
      };
    },

    createMeasureClone(frame) {
      const clone = frame.cloneNode(true);
      clone.classList.remove("frame");
      clone.classList.remove("framefh");
      clone.classList.add("clone-f", "clone-f-measure", "no-transition");
      
      clone.style.boxSizing = getComputedStyle(frame).boxSizing;

      frame.parentNode.insertBefore(clone, frame.nextSibling);

      // Force reflow to ensure styles are applied
      clone.offsetHeight;
      
      return clone;
    },

    async calculateImageLayout(frame, ife, bfe, scale, left, top, frameData) {
      let {width, height, borderWidth, padding, props } = frameData;
      
      frame.style.width = width + "px";
      frame.style.height = height + "px";
      this.applyFrameProps(frame, props);
      frame.style.borderWidth = borderWidth + "px";
      
      await new Promise(requestAnimationFrame);

      ife.style.transform = `scale(${scale})`;
      ife.style.left = `${left}px`;
      ife.style.top = `${top}px`;

      // Wait for DOM update
      await new Promise(requestAnimationFrame);
      
      const imgRect = ife.getBoundingClientRect();
      const frameRect = bfe.getBoundingClientRect();
      
      let bigLeft = left;
      let bigTop = top;
      
      let offsetX = 0;
      let offsetY = 0;

      const margin = 0; 

      if (imgRect.left > frameRect.left + margin) {
        offsetX = frameRect.left - imgRect.left - margin;
      } else if (imgRect.right < frameRect.right - margin) {
        offsetX = frameRect.right - imgRect.right + margin;
      }

      if (imgRect.top > frameRect.top + margin) {
        offsetY += frameRect.top - imgRect.top - margin;
      }else if (imgRect.bottom < frameRect.bottom - margin) {
        offsetY += frameRect.bottom - imgRect.bottom + margin;
      }

      if (offsetX !== 0 || offsetY !== 0) {
        bigLeft += offsetX;
        bigTop += offsetY;
      }

      ife.style.left = `${bigLeft}px`;
      ife.style.top = `${bigTop}px`;

      return { left: bigLeft, top: bigTop, scale };
    },

    async smoothSizeAdjust({frame, scale, left, top, frameData}) {
      const clone = this.createMeasureClone(frame);

      const cloneImg = clone.querySelector(".img-box img");
      const cloneBox = clone.dataset.frameEdge === "Wrapped" ? clone.querySelector(".img-print") : clone.querySelector(".img-box");

      const layout = await this.calculateImageLayout(
        clone, 
        cloneImg, 
        cloneBox, 
        scale, 
        left, 
        top, 
        frameData
      );

      // Clean up clone after measurement
      clone.remove();

      this.applyFinalLayout(frame, layout, frameData);

      frame.offsetHeight;

      return true;
    },

    applyFinalLayout(frame, layout, frameData) {
      const img = frame.querySelector(".img-box img");
      const imgBox = frame.querySelector(".img-box");
      frame.offsetHeight;
      let {width, height, borderWidth, padding, props } = frameData;
      
      frame.style.width = width + "px";
      frame.style.height = height + "px";
      this.applyFrameProps(frame, props);
      frame.style.borderWidth = borderWidth + "px";

      img.dataset.scaleVal = layout.scale;
      img.style.left = layout.left + "px";
      img.style.top  = layout.top + "px";
      img.style.transform = `scale(${layout.scale})`;

      frame.offsetHeight;
    },

    applyFrameProps(frame, props) {
      const vars = props || {};
      if (!vars) return;

      Object.entries(vars).forEach(([key, value]) => {
        if (!key.startsWith('--')) return;
        frame.style.setProperty(key, `${value}`);
      });
    },

    pendingFrameOperations: new Map(),// Maps frameId -> { cleanupTimer, onFrameEnd, frame }

    async sizeAdjustPosition({frame, Ra4Sc, action, oldWdiFC, oldHdiFC, newLeft, newTop, newScale, frameProps}) {
      const frameId = frame.dataset.frameId;
      
      // Cancel any pending operation for this frame
      if (this.pendingFrameOperations.has(frameId)) {
        console.log(`Canceling pending operation for frame ${frameId}`);
        const pending = this.pendingFrameOperations.get(frameId);
        
        // Clear timeout if exists
        if (pending.cleanupTimer) {
          clearTimeout(pending.cleanupTimer);
        }
        
        // Remove event listener if exists
        if (pending.onFrameEnd) {
          pending.frame.removeEventListener("transitionend", pending.onFrameEnd);
        }
        
        // Remove from map
        this.pendingFrameOperations.delete(frameId);
      }
      // document.querySelectorAll(".clone-f").forEach(f=> f.remove());
      var ife = frame.querySelector(".img-box img");
      if (!ife || !ife.complete || ife.naturalWidth === 0) {
        return new Promise((resolve) => {
          ife.addEventListener(
            "load",
            async () => {
              await this.sizeAdjustPosition({frame, Ra4Sc, action, oldWdiFC, oldHdiFC, newLeft, newTop, newScale});
              resolve();
            },
            { once: true }
          );
        });
      }
      if (!ife || !ife.complete || ife.naturalWidth === 0) return;

      const frames = w.Cnvs.State.data.frames;
      const sF = frames.find(f => f.id == frame.dataset.frameId);

      const css = sF.cssStyles;
      const width = css.width ?? frame.style.width;
      const height = css.height ?? frame.style.height;
      const borderWidth = css.borderWidth ?? frame.style.borderWidth;
      const padding = css.padding ?? frame.style.padding;
      
      const FWidthPx   = this.toNumberPx(width);
      const FHeightPx  = this.toNumberPx(height);
      const FBorderPx  = this.toNumberPx(borderWidth);
      const FPaddingPx = this.toNumberPx(padding);  
      
      // Prefer stored frameVars, fallback to computed styles
      const vars = frameProps || {};
      const styles = getComputedStyle(frame);
      const readVar = (key) => {
        if (vars[key] !== undefined && vars[key] !== null) {
          return parseFloat(vars[key]).toFixed(2);
        }
        return parseFloat(styles.getPropertyValue(key));
      };

      // Read values (same ones used by .img-print)
      const bWidth  = readVar('--b-width');
      const bHeight = readVar('--b-height');
      const wWidth  = readVar('--w-width');
      const wHeight = readVar('--w-height');
      const wInches = readVar('--p-winches');
      const hInches = readVar('--p-hinches');

      // Decide which element controls image sizing
      const sizeElement = frame.dataset.frameEdge === "Wrapped" ? frame.querySelector(".img-print") : frame.querySelector(".img-box");
      let boxw, boxh;
      if (sizeElement && sizeElement.classList.contains("img-print")) {
        const inchW = bWidth  / wInches;
        const inchH = bHeight / hInches;
        const BLEED = 1.5;
        const imgPrint = {
          width:  inchW * (wInches + BLEED * 2),
          height: inchH * (hInches + BLEED * 2),
          paddingX: inchW * BLEED,
          paddingY: inchH * BLEED,
          left: -inchW * BLEED,
          top:  -inchH * BLEED
        };
         boxw = imgPrint.width + (imgPrint.paddingX * 2);
         boxh = imgPrint.height + (imgPrint.paddingY * 2);
      } else {
        // Normal img-box case
        boxw = bWidth;
        boxh = bHeight;
      }
     
      var bfe = sizeElement || frame.querySelector(".img-box");
      const natW = ife.naturalWidth;
      const natH = ife.naturalHeight;
      
      // Only use them if they're explicitly passed (for border changes)
      const useProvidedValues = (newLeft !== undefined && newTop !== undefined && newScale !== undefined);
      
      var oldLeft = useProvidedValues ? parseFloat(newLeft) : (parseFloat(ife.style.left) || parseFloat(ife.offsetLeft));
      var oldTop = useProvidedValues ? parseFloat(newTop) : (parseFloat(ife.style.top) || parseFloat(ife.offsetTop));
      const crSc = useProvidedValues ? parseFloat(newScale) : (Cnvs.Utils.getScale(ife) || 1);
      
      console.log("------------crSc", crSc);
      
      Ra4Sc = Ra4Sc || 1;

      Cnvs.Popup.current.ceScale = !crSc ? 0 : crSc * Ra4Sc;

      let posrotation = "h";
      if (posrotation == "v") {
        var minScaleX = boxw / natH;
        var minScaleY = boxh / natW;
      } else {
        var minScaleX = boxw / natW;
        var minScaleY = boxh / natH;
      }

      // Add 1% extra size
      const minScale = Math.max(minScaleX, minScaleY);
      w.Cnvs.Popup.current.ceScale =
        ife.dataset.scale === "more"
          ? Math.max(Cnvs.Popup.current.ceScale, minScale)
          : minScale;

      let bigLeft = oldLeft;
      let bigTop = oldTop;
      if (crSc > 0 && action != "PageLoad") {
        if (action === "shape") {
          const NEWelWCe = (natW - boxw) / 2;
          const NEWelHCe = (natH - boxh) / 2;

          const WdiFC = (oldWdiFC / crSc) * Cnvs.Popup.current.ceScale;
          const HdiFC = (oldHdiFC / crSc) * Cnvs.Popup.current.ceScale;

          bigLeft = -NEWelWCe + WdiFC;
          bigTop = -NEWelHCe + HdiFC;
          // ife.style.left = `${bigLeft}px`;
          // ife.style.top = `${bigTop}px`;
        } else {
          var newScale = parseFloat(Cnvs.Popup.current.ceScale);
          var curentScale = parseFloat(crSc);
          var newScaleDifrence = 1 - newScale;
          var mnwXsd = (ife.naturalWidth * newScaleDifrence) / 2;
          var mnhXsd = (ife.naturalHeight * newScaleDifrence) / 2;
          var curentScaleDifrence = 1 - curentScale;
          var pnwXsd = (ife.naturalWidth * curentScaleDifrence) / 2;
          var pnhXsd = (ife.naturalHeight * curentScaleDifrence) / 2;
          var pwdis = pnwXsd + oldLeft;
          var phdis = pnhXsd + oldTop;
          var mwdis = (pwdis / curentScale) * newScale;
          var mhdis = (phdis / curentScale) * newScale;
          bigLeft = -mnwXsd + mwdis;
          bigTop = -mnhXsd + mhdis;
          // ife.style.left = `${bigLeft}px`;
          // ife.style.top = `${bigTop}px`;
        }
      }
      const frameData = {
        width: wWidth ?? FWidthPx,
        height: wHeight ?? FHeightPx,
        borderWidth: FBorderPx,
        padding: 0,
        props: frameProps
      }
      await this.smoothSizeAdjust({frame, scale: Cnvs.Popup.current.ceScale,left: bigLeft, top: bigTop, action, frameData});

      frame.style.setProperty('--frame-size', `${FBorderPx}px`);

      let cleanupTimer = null;
      let finished = false;
      const cleanup = () => {
        if (finished) return;
        finished = true;
        // Clear the timeout if it hasn't executed yet
        if (cleanupTimer) {
          clearTimeout(cleanupTimer);
          cleanupTimer = null;
        }
        frame.removeEventListener("transitionend", onFrameEnd);
        
        // Remove the stored reference
        if (frame._onFrameEnd === onFrameEnd) {
          frame._onFrameEnd = null;
        }
        // Remove from pending operations map
        if (this.pendingFrameOperations.get(frameId)?.onFrameEnd === onFrameEnd) {
          this.pendingFrameOperations.delete(frameId);
        }

        this.sizeAdjuster(ife, bfe, frame);
        ife.style.opacity = "1";
        ife.style.pointerEvents = "auto";
      };

      const onFrameEnd = (e) => {
        const FRAME_PROPS = ["width","height","padding","border"];
        if (!FRAME_PROPS.some(p => e.propertyName.startsWith(p))) return;
        cleanup();
      };

      // Clean up any existing listener on the frame itself
      if (frame._onFrameEnd) {
        frame.removeEventListener("transitionend", frame._onFrameEnd);
      }
      
      // Set up new listener
      frame._onFrameEnd = onFrameEnd;
      frame.addEventListener("transitionend", onFrameEnd);

      const MAX_TRANSITION_TIME = 350;
      cleanupTimer = setTimeout(cleanup, MAX_TRANSITION_TIME);
      
      // Store this operation in the pending map
      this.pendingFrameOperations.set(frameId, {
        cleanupTimer,
        onFrameEnd,
        frame
      });
      
      return true;
    },

    async sizeAdjuster(ife, bfe, frame) {
      await new Promise(requestAnimationFrame);
      frame.classList.add('no-transition-adjust');
      const imgRect = ife.getBoundingClientRect();
      const frameRect = bfe.getBoundingClientRect();
      
      let bigLeft = parseFloat(ife.style.left) || ife.offsetLeft;
      let bigTop = parseFloat(ife.style.top) || ife.offsetTop;
      let offsetX = 0;
      let offsetY = 0;

      const margin = 0; 

      if (imgRect.left > frameRect.left + margin) {
        offsetX += frameRect.left - imgRect.left - margin;
      }else if (imgRect.right < frameRect.right - margin) {
        offsetX += frameRect.right - imgRect.right + margin;
      }

      if (imgRect.top > frameRect.top + margin) {
        offsetY += frameRect.top - imgRect.top - margin;
      }else if (imgRect.bottom < frameRect.bottom - margin) {
        offsetY += frameRect.bottom - imgRect.bottom + margin;
      }


      if (offsetX !== 0 || offsetY !== 0) {
        bigLeft += offsetX;
        bigTop += offsetY;
      }
      ife.style.left = `${bigLeft}px`;
      ife.style.top = `${bigTop}px`;
      frame.classList.remove('no-transition-adjust');
    },

    toNumberPx(value, fallback = 0) {
      if (value === null || value === undefined) return fallback;

      if (typeof value === "number") return value;

      
      if (typeof value === "string") {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? fallback : parsed;
      }
      return fallback;
    },

    // Apply Edit Settings new Position
    AESnP() {
      cLog("🔄 Cnvs.Frames: Applying edit settings to main preview");

      try {
        // Get popup state
        const pu = Cnvs.Popup.current;
        if (!pu.isOpen || !pu.ceF || !pu.cuF) {
          console.warn("⚠️ Popup state not available, using fallback");
          return this.AESnPFallback();
        }

        // Handle border changes
        if (pu.ceF?.dataset.frameBorder != pu.cuF?.dataset.frameBorder) {
          pu.cuF.dataset.frameBorder = pu.ceF.dataset.frameBorder;
          let { widthInInches: fw, heightInInches: fh } = pu.cuF.dataset;
          fw = parseFloat(fw);
          fh = parseFloat(fh);

          const iw = parseFloat(getComputedStyle(pu.cuF).width),
            ra = iw / fw,
            ss = Math.min(fw, fh),
            bs =
              pu.ceF.dataset.frameBorder == "No Mat"
                ? ss * 0
                : pu.ceF.dataset.frameBorder == "Standard"
                  ? ss * 0.1
                  : ss * 0.2,
            ab = bs * ra;

          pu.cuF.style.padding = ab + "px";

          // Update cssStyles when padding changes
          const frameId = pu.cuF.dataset.frameId;
          if (frameId) {
            this.updateFrameCssStyles(frameId, {
              padding: ab + "px"
            });
          }
        }

        // Use popup state values
        var mw = parseFloat(w.getComputedStyle(pu.cuB).width);
        var pw = parseFloat(w.getComputedStyle(pu.ceB).width);
        var ms = pu.ceScale * (mw / pw);
        pu.cuI.style.transform = `scale(${ms})`;

        var newLeft = parseFloat(pu.ceI.style.left);
        var newTop = parseFloat(pu.ceI.style.top);
        var currentMainScale = ms;
        var currentPopupScale = pu.ceScale;
        var msd = 1 - currentMainScale;
        var mnwXsd = (pu.ceNW * msd) / 2;
        var mnhXsd = (pu.ceNH * msd) / 2;
        var psd = 1 - currentPopupScale;
        var pnwXsd = (pu.ceNW * psd) / 2;
        var pnhXsd = (pu.ceNH * psd) / 2;
        var pwdis = pnwXsd + newLeft;
        var phdis = pnhXsd + newTop;
        var mwdis = (pwdis / currentPopupScale) * currentMainScale;
        var mhdis = (phdis / currentPopupScale) * currentMainScale;
        var bigLeft = -mnwXsd + mwdis;
        var bigTop = -mnhXsd + mhdis;

        pu.cuI.style.left = `${bigLeft}px`;
        pu.cuI.style.top = `${bigTop}px`;

        // Update popup state with new main image position
        Cnvs.Popup.update({
          cuLeft: bigLeft,
          cuTop: bigTop,
        });

        cLog(`📐 Scale: ${currentPopupScale} → ${currentMainScale}`);
        cLog(`🎯 Position: (${newLeft}, ${newTop}) → (${bigLeft}, ${bigTop})`);
      } catch (error) {
        console.error("❌ Error in Cnvs.Frames.AESnP:", error);
        this.AESnPFallback();
      }
    },

    // Fallback method for when popup state is not available
    AESnPFallback() {
      cLog("🔄 Cnvs.Frames: Using fallback AESnP method");
      try {
        // Fallback: just apply basic scale using global variables
        const mw = parseFloat(w.getComputedStyle(w.cuB).width);
        const pw = parseFloat(w.getComputedStyle(w.ceB).width);
        const ms = Cnvs.Popup.current.ceScale * (mw / pw);
        w.cuI.style.transform = `scale(${ms})`;
      } catch (error) {
        console.error("❌ Error in fallback AESnP:", error);
      }
    },

    // Handle Swiper initialization or destruction
    handleSwiper(frames) {
      var acFramesL = S$$(".framefh").length;
      if (
        typeof w.framesswiper !== "undefined" &&
        (w.framesswiper || acFramesL < 1)
      ) {
        w.framesswiper.destroy();
        S$Q("#img-preview > div:nth-child(1)")?.classList.remove("hidden");
      } else if (w.dType === "M" && acFramesL < 1) {
        S$Q("#img-preview > div:nth-child(1)")?.classList.remove("hidden");
      }

      if (dType === "M" && acFramesL > 0) {
        cLog("🔄 Cnvs.Frames: Initializing Swiper");
        S$Q("#img-preview > div:nth-child(1)")?.classList.add("hidden");
        w.framesswiper = new Swiper(".dp_col", {
          grabCursor: true,
          centeredSlides: true,
          freeMode: true,
          spaceBetween: 30,
          slidesPerView: "auto",
        });
        S$$(".framefh").forEach((b) => {
          b.addEventListener("click", w.editpu || this.editpu.bind(this));

          ["gesturestart", "gesturechange", "gestureend"].forEach(evt => {
            document.addEventListener(evt, e => {
              e.preventDefault();
            }, { passive: false });
          });
          
        });
        
      }

      if(dType === "M"){
        
        S$$(".frame").forEach((b) =>{
          b.removeEventListener('touchstart', (e) => Cnvs.Frames.touchStart(e), {passive: false});
          b.addEventListener('touchstart', (e) => Cnvs.Frames.touchStart(e), {passive: false});
        })
      }
    },

    // ================================================================
    // UTILITY FUNCTIONS
    // ================================================================

    // Helper function to update frame cssStyles in state
    updateFrameCssStyles(frameId, styles) {
      if (!frameId || !Cnvs?.State?.getFrame) return false;

      try {
        const frameState = Cnvs.State.getFrame(frameId);
        if (frameState) {
          const updatedStyles = {
            ...frameState.cssStyles,
            ...styles,
          };

          Cnvs.State.updateFrame(frameId, {
            cssStyles: updatedStyles,
          });

          cLog(`✅ Updated cssStyles for frame ${frameId}:`, updatedStyles);
          return true;
        }
      } catch (error) {
        console.error("❌ Error updating frame cssStyles:", error);
      }
      return false;
    },

    // Helper function to sync DOM styles to state
    syncFrameStylesToState(frameElement) {
      if (!frameElement?.dataset?.frameId) return false;

      try {
        const frameId = frameElement.dataset.frameId;
        const computedStyles = window.getComputedStyle(frameElement);

        const currentStyles = {
          height: frameElement.style.height || computedStyles.height,
          width: frameElement.style.width || computedStyles.width,
          borderWidth:
          frameElement.style.borderWidth || computedStyles.borderWidth,
          frameSize:
          frameElement.style.frameSize || computedStyles.frameSize,
          padding: frameElement.style.padding || computedStyles.padding,
        };

        return this.updateFrameCssStyles(frameId, currentStyles);
      } catch (error) {
        console.error("❌ Error syncing frame styles to state:", error);
        return false;
      }
    },

    // Get all frame elements
    getAllFrames() {
      return document.querySelectorAll(".frame") || [];
    },

    // Get frame by ID
    getFrameById(frameId) {
      return document.querySelector(`[data-frame-id="${frameId}"]`);
    },

    // Get module status
    getStatus() {
      return {
        loaded: true,
        functions: [
          "addFrame",
          "setFID",
          "updateFrameSizes",
          "setupFrameEventListeners",
          "updateAllFramesInches",
          "checkPPI",
          "handleSwiper",
          "editpu",
          "AESnP",
        ],
        frameCount: this.getAllFrames().length,
      };
    },

    // Log module info
    logInfo() {
      cLog("📦 Cnvs.Frames module loaded (full extraction)");
      cLog("🖼️ Available functions:", [
        "addFrame()",
        "setFID()",
        "updateFrameSizes()",
        "setupFrameEventListeners()",
        "updateAllFramesInches()",
        "checkPPI()",
        "handleSwiper()",
        "editpu()",
        "AESnP()",
        "handleCheckboxChange()",
        "endSEdit()",
        "updateSingleFrameSize()",
        "updateSingleFrameBorder()",
      ]);
      cLog(`📊 Current frames: ${this.getAllFrames().length}`);
    },

    // ================================================================
    // FRAME EDITING FUNCTIONS
    // ================================================================

    /**
     * Handle frame editing popup
     * @param {Event} e - Click event
     * @returns {boolean} - Success status
     */
    editpu(e) {
      cLog("✏️ Cnvs.Frames: Opening edit popup");
      if (Cnvs.Popup.current.isOpen == true) return;
      Cnvs.Popup.current.isOpen = true;

      var ci = e.target.closest(".framefh");
      var edi = ci.getAttribute("data-frame-index");
      let sci;

      const el = S$Q('.dp_epu-body .frame');
      if (el) {
          el.remove();
      }

      try {
        sci = ci.cloneNode(true);
        sci.classList.add("no-transition");
        for (const img of sci.querySelectorAll("img")) {
          if (!img.complete || img.naturalWidth === 0) throw new Error();
        }
      } catch {
        const frame = Cnvs.State.data.frames.find(f => f.positionIndex == edi);
        if (!frame || !frame.image) {
          this.handleFrameRemoval(frame?.id, ci.closest(".frame_container"));
          return;
        }

        const { file, filestackUrl } = frame.image;
        const src = file instanceof Blob ? URL.createObjectURL(file) : filestackUrl?.startsWith("http") ? filestackUrl : null;

        if (!src) {
          this.handleFrameRemoval(frame.id, ci.closest(".frame_container"));
          return;
        }

        ci.querySelector("img")?.setAttribute("src", src);
        sci = ci.cloneNode(true);

        this.updateFrameCssStyles(frame.id, { previewURL: src });
      }

      const heightInInches = parseInt(sci.getAttribute("data-height-in-inches"), 10);
      const widthInInches = parseInt(sci.getAttribute("data-width-in-inches"), 10);
      let widthPx, heightPx, scp, maxWidth, maxHeight;
      let maxH = w.innerHeight * 0.5, maxW =  w.innerWidth * 0.8;

      const mFrameHeight = parseInt(sci.style.height)
      if (dType == "D") {
        widthPx = (280 / heightInInches) * widthInInches;
        heightPx = 280;
        var h4calc = sci.dataset.frameStyle == "None" ? heightPx : heightPx * 0.9;
        scp = h4calc / parseInt(sci.style.height);
      } else {

        let avaible = w.innerHeight - parseFloat(w.getComputedStyle(S$Q(".dp_epu-footer")).height) - 50;
        maxHeight = Math.min(maxH, avaible);
        maxWidth = maxW;

        const ratio = widthInInches / heightInInches;

        if (maxWidth / maxHeight > ratio) {
          heightPx = maxHeight;
          widthPx = maxHeight * ratio;
        } else {
          widthPx = maxWidth;
          heightPx = maxWidth / ratio;
        }
        var h4calc = sci.dataset.frameStyle == "None" ? heightPx : heightPx * 0.9;
        scp = h4calc / parseInt(sci.style.height);
      }

      if(sci.dataset.frameStyle == "None"){
        sci.style.height = `${heightPx}px`;
        sci.style.width = `${widthPx}px`;
      }else{
        heightPx = heightPx * 0.9;
        widthPx = widthPx * 0.9;
        sci.style.height = `${heightPx}px`;
        sci.style.width = `${widthPx}px`;
      }


      const borderInInches = 0.9;
      let adjustedBorder = (borderInInches / heightInInches) * heightPx;

      let frameVars;
      if (sci.dataset.frameStyle === "None") {
        const sidePx = this.sidePixels(widthInInches, widthPx, borderInInches);
        sci.style.height = `${heightPx + sidePx}px`;
        sci.style.width = `${widthPx + sidePx}px`;
        sci.style.setProperty('--p-hinches', `${heightInInches}`);
        sci.style.setProperty('--p-winches', `${widthInInches}`);
        sci.style.setProperty('--w-height', `${heightPx + sidePx}px`);
        sci.style.setProperty('--w-width', `${widthPx + sidePx}px`);
        sci.style.setProperty('--b-height', `${heightPx}px`);
        sci.style.setProperty('--b-width', `${widthPx}px`);
        frameVars = {
          '--p-hinches': heightInInches,
          '--p-winches': widthInInches,
          '--w-height':  (heightPx + sidePx) + "px",
          '--w-width':   (widthPx + sidePx) + "px",
          '--b-height':  heightPx + "px",
          '--b-width':   widthPx + "px",
          adjustedBorder: 0,
        };
        adjustedBorder= 0;

        scp = parseInt(heightPx + sidePx) / mFrameHeight;
      } else {
        sci.style.height = `${heightPx}px`;
        sci.style.width = `${widthPx}px`;
        sci.style.setProperty('--p-hinches', `${heightInInches}`);
        sci.style.setProperty('--p-winches', `${widthInInches}`);
        sci.style.setProperty('--w-height', `${heightPx}px`);
        sci.style.setProperty('--w-width', `${widthPx}px`);
        sci.style.setProperty('--b-height', `${heightPx}px`);
        sci.style.setProperty('--b-width', `${widthPx}px`);
        frameVars = {
          '--p-hinches': heightInInches,
          '--p-winches': widthInInches,
          '--w-height':  heightPx + "px",
          '--w-width':   widthPx + "px",
          '--b-height':  heightPx + "px",
          '--b-width':   widthPx + "px",
          adjustedBorder: adjustedBorder + "px",
        };
        scp = parseInt(heightPx) / mFrameHeight;
      }

      sci.style.borderWidth = `${adjustedBorder}px`;
      sci.style.setProperty('--frame-size', `${adjustedBorder}px`);
      
      const varSize = widthInInches < heightInInches ? widthInInches + "x" + heightInInches : heightInInches + "x" + widthInInches;

      // Update state's cssStyles for popup frame when DOM styles change
      const frameId = sci.dataset.frameId;
      if (frameId) {
        this.updateFrameCssStyles(frameId, {
          height: sci.style.height,
          width: sci.style.width,
          borderWidth: adjustedBorder + "px",
          // padding: scipadding + "px",
        });
      }

      S$Q(".dp_epu-body").appendChild(sci);
      S$Q(".dp_epu").style.display = "block";
      S$Q(".dp_epu").setAttribute("data-edit-index", edi);
      S$Q(".dp_epu-sbm_option.sideB").style.display = "flex";
      
      // Initialize popup state management
      Cnvs.State.openPopup();

      // Get state references for easier access
      const pu = Cnvs.Popup.current;

      const newScale = Cnvs.Utils.getScale(pu.ceI) * scp;

      // Update popup state with calculated values
      Cnvs.Popup.update({
        ceScale: newScale,
        ceStyle: sci.getAttribute("data-frame-style").trim(),
        ceEdge: sci.dataset.frameEdge,
        ceSize: widthInInches + "x" + heightInInches,
        cuScale: Cnvs.Utils.getScale(pu.ceI),
      });

      const currentFrame = Cnvs.State.getFrame(pu.cuF.dataset.frameId);
      if(currentFrame) pu.ceF.dataset.framePrice = currentFrame.price;
      
      pu.ceI.style.transform = `scale(${newScale})`;

      // Update popup state with calculated values
      Cnvs.Popup.update({
        ceScale: newScale,
      });

      S$Q(".dp_epu-ftitle span").innerText = pu.ceStyle + " - " + varSize;
      var mainScaleDifference = 1 - pu.cuScale;
      var mainNaturalWidthXScaleDifference = (pu.ceNW * mainScaleDifference) / 2;
      var mainNaturalHeightXScaleDifference = (pu.ceNH * mainScaleDifference) / 2;
      var popupScaleDifference = 1 - pu.ceScale;
      var popupNaturalWidthXScaleDifference = (pu.ceNW * popupScaleDifference) / 2;
      var popupNaturalHeightXScaleDifference = (pu.ceNH * popupScaleDifference) / 2;
      var popupwdis = mainNaturalWidthXScaleDifference + (parseFloat(pu.cuI.style.left) || parseFloat(pu.cuI.offsetLeft));
      var popuphdis = mainNaturalHeightXScaleDifference + (parseFloat(pu.cuI.style.top) || parseFloat(pu.cuI.offsetTop));
      var mainwdis = (popupwdis / pu.cuScale) * pu.ceScale;
      var mainhdis = (popuphdis / pu.cuScale) * pu.ceScale;
      var bigLeft = -popupNaturalWidthXScaleDifference + mainwdis;
      var bigTop = -popupNaturalHeightXScaleDifference + mainhdis;

      if (!pu.cuBW) {
        pu.ceI.style.filter = 'none';
        pu.ceI.style.webkitFilter = 'none';
      } else {
        pu.ceI.style.filter = 'grayscale(100%)';
        pu.ceI.style.webkitFilter = 'grayscale(100%)';
      }
      pu.ceI.style.left = `${bigLeft}px`;
      pu.ceI.style.top = `${bigTop}px`;

      S$$(".dp_epu-footer .dp_epu__size-box__item").forEach((sizeItem) => {
        const style = pu?.ceStyle.trim();
        const style4Search = style === 'None' ? 'Wrapped_Canvas' : style;
        const size = sizeItem.dataset.value.split('x');
        const sortedSize = parseInt(size[0]) < parseInt(size[1]) ? `${style4Search}__${size[0]}x${size[1]}` : `${style4Search}__${size[1]}x${size[0]}`;
        const frameData = Cnvs.Utils.findPByKey(sortedSize);
        sizeItem.querySelector("label:last-of-type").innerText = `$${frameData.price} Each`;
      });

      this.sizeAdjustPosition({ frame: pu.ceF, Ra4Sc: 1, action: "PageLoad",  newLeft: bigLeft, newTop: bigTop, newScale, frameProps: frameVars});

      Cnvs.Images.loadImageForEditing();

      sci.classList.remove("no-transition");
      // Update popup state with position
      Cnvs.Popup.update({
        ceLeft: bigLeft,
        ceTop: bigTop,
      });

      if (Cnvs.Frames.resetPopupParameters) {
        Cnvs.Frames.resetPopupParameters();
      }

      this.openPopupAnimation();
    },

    /**
     * Reset popup parameters and UI elements
     * @returns {boolean} - Success status
     */
    resetPopupParameters() {
      cLog("🔄 Cnvs.Frames: Resetting popup parameters");
      const pu = Cnvs.Popup.current;

      try {
        // Reset size, style, and border selections in one-liners
        S$$(".swiper3 .swiper-slide > div").forEach(b => b.classList.remove("selected"));
        S$Q(`.swiper3 .swiper-slide[data-size*="${pu.ceSize}"] > div`)?.classList.add("selected");
        S$$(".swiper4 .swiper-slide > div").forEach(b => b.classList.remove("selected"));
        S$Q(`.swiper4 .swiper-slide[data-style*="${pu.ceStyle}"] > div`)?.classList.add("selected");
        S$$(".dp_epu__border-box__item").forEach(b => b.classList.remove("selected"));
        S$Q(`.dp_epu__border-box__item[data-edge*="${pu.ceEdge}"]`)?.classList.add("selected");

        // Reset acrylic checkbox
        const acrCheckbox = S$Q(".dp_epu #epuacr");
        if (acrCheckbox) acrCheckbox.checked = pu.ceAcrylic === "true";

        return true;
      } catch (error) {
        console.error("❌ Error in resetPopupParameters:", error);
        return false;
      }
    },

    /**
     * Update size for a single frame in the edit popup
     * @param {number} widthInInches - New width in inches
     * @param {number} heightInInches - New height in inches
     * @param {number} fri - Frame index
     * @returns {boolean} - Success status
     */
    async updateSingleFrameSize(widthInInches, heightInInches, fri, i2s) {
      const action = "shape"
      cLog(`📐 Cnvs.Frames: Updating frame sizes - Action: ${action}, i2s: ${i2s}`);

      try {
         const frame = S$Q(".dp_epu-body .frame");
        if (!frame) {
          console.error("❌ Frame not found in edit popup");
          return false;
        }

        if (Cnvs.Popup.current.ceSize === widthInInches + "x" + heightInInches) {
          console.error(`⚠️ same size type: ${Cnvs.Popup.current.ceSize}`);
          return false;
        }

        const selFrame = frame.getAttribute("data-frame-style");
        const style4Search = selFrame === 'None' ? 'Wrapped_Canvas' : selFrame;
        const fID = parseInt(widthInInches) < parseInt(heightInInches) ? `${style4Search}__${widthInInches}x${heightInInches}` : `${style4Search}__${heightInInches}x${widthInInches}`;

        // Get frame data with product lookup
        const frameProduct = Cnvs?.Utils?.findPByKey(fID) || { price: 55, id: `fallback-${Date.now()}`, };
        const fPrice = frameProduct.price;
        const fshopid = frameProduct.id;
        frame.dataset.vid = fshopid;
        frame.dataset.framePrice = fPrice;
        frame.setAttribute("data-width-in-inches", widthInInches);
        frame.setAttribute("data-height-in-inches", heightInInches);

        const style = selFrame;
        // Calculate new dimensions
        const bi = 0.86; // Border inch
        const wi = parseInt(widthInInches, 10);
        const hi = parseInt(heightInInches, 10);
        let ah = 280; // Base height
        let aw = (wi / hi) * ah; // Proportional width
        let ab = (bi / hi) * ah; // Border thickness
        let maxH = w.innerHeight * 0.5, maxW =  w.innerWidth * 0.8;
        ah = style === "None" ? ah : ah * 0.9;
        aw = style === "None" ? aw : aw * 0.9;
        // Adjust for mobile
        if (w.dType === "M") {
              // ah =  w.innerHeight * 0.5;
              maxH = style === "None" ? maxH : maxH * 0.9;
              maxW = style === "None" ? maxW : maxW * 0.9;
              let avaible = w.innerHeight - parseFloat(w.getComputedStyle(S$Q(".dp_epu-footer")).height) - 50;
              maxH = Math.min(maxH, avaible);

              const maxWidth = maxW;
              if (aw > maxWidth) {
                  aw = maxWidth;
                  ah = (hi / wi) * aw;
                  ab = (bi / hi) * ah;
              }
        }else{
          const container = document.querySelector(".dp_epu-box");
          const width = aw;
          const dif = (parseInt(window.getComputedStyle(container).width) - 40 - width);
          if(dif < 120){
            const val = (width - (120 - dif));
            const height = (val / widthInInches) * heightInInches;
            aw = val;
            ah = height;
          }
        }

        // Calculate maximum dimensions
        const { maxFrameHeight, maxFrameWidth } = this.getWstAndTstFrameD([frame]);
        const { maxHeight, maxWidth } = w.dType === "M" ? { maxHeight: maxH , maxWidth:  maxW } : { maxHeight: ah, maxWidth: aw };

        cLog(`📱 Device type: ${w.dType}, Max dimensions: ${maxWidth}x${maxHeight}`);

        // Calculate scaling ratios
        const hr = maxFrameHeight / maxHeight;
        const wr = maxFrameWidth / maxWidth;
        const a2c = hr > wr ? "h" : "w";

        // Update each frame with error handling
        let updatedCount = 0;
        let errorCount = 0;

        await this.updateFrameSize(frame, maxFrameHeight, maxHeight, maxFrameWidth, maxWidth, a2c, "shape", i2s);

        
        // Update global size reference
        Cnvs.Popup.update({
          ceSize: widthInInches + "x" + heightInInches,
          ceSizeVariant:
            widthInInches < heightInInches
              ? widthInInches + "x" + heightInInches
              : heightInInches + "x" + widthInInches,
          ceWidth: widthInInches,
          ceHeight: heightInInches,
        });

        return true;
      } catch (error) {
        console.error("❌ Error in updateSingleFrameSize:", error);
        return false;
      }
    },

    /**
     * Update style for a single frame in the edit popup
     * @param {number} widthInInches - New width in inches
     * @param {number} heightInInches - New height in inches
     * @param {number} fri - Frame index
     * @returns {boolean} - Success status
     */
    async updateSingleFrameStyle(style, fri, i2s) {
      const action = "styles"
      cLog(`📐 Cnvs.Frames: Updating frame sizes - Action: ${action}, i2s: ${i2s}`);

      try {
         const frame = S$Q(".dp_epu-body .frame");
        if (!frame) {
          console.error("❌ Frame not found in edit popup");
          return false;
        }
        const widthInInches = parseInt(
          frame.getAttribute("data-width-in-inches"),
          10
        );
        const heightInInches = parseInt(
          frame.getAttribute("data-height-in-inches"),
          10
        );
        
        const selFrame = frame.getAttribute("data-frame-style");

        if(selFrame === style){
          console.error(`⚠️ same style type: ${style}`);
          return false;
        }

        // const style4Search = selFrame === 'None' ? 'Wrapped_Canvas' : selFrame;
        const style4Search = style === 'None' ? 'Wrapped_Canvas' : style;
        const fID = parseInt(widthInInches) < parseInt(heightInInches) ? `${style4Search}__${widthInInches}x${heightInInches}` : `${style4Search}__${heightInInches}x${widthInInches}`;

        // Get frame data with product lookup
        const frameProduct = Cnvs?.Utils?.findPByKey(fID) || { price: 55, id: `fallback-${Date.now()}`, };
        const fPrice = frameProduct.price;
        const fshopid = frameProduct.id;
        frame.dataset.vid = fshopid;
        frame.dataset.framePrice = fPrice;

        S$$(".dp_epu-footer .dp_epu__size-box__item").forEach((sizeItem) => {
          sizeItem.querySelector("label:last-of-type").innerText = `$${frameProduct.price} Each`;
        });

        S$Q('.dp_epu-body .frame').setAttribute('data-frame-style', style);

        if (!(selFrame === "None" || style === "None")) {
          // Update global size reference
          Cnvs.Popup.update({
            ceStyle: style 
          });
          return true;
        } 
        
        // Calculate new dimensions
        const bi = 0.86; // Border inch
        const wi = parseInt(widthInInches, 10);
        const hi = parseInt(heightInInches, 10);
        let ah = 280; // Base height
        let aw = (wi / hi) * ah; // Proportional width
        let ab = (bi / hi) * ah; // Border thickness
        let maxH = w.innerHeight * 0.5, maxW =  w.innerWidth * 0.8;

        ah = style === "None" ? ah : ah * 0.9;
        aw = style === "None" ? aw : aw * 0.9;
        // Adjust for mobile
        if (w.dType === "M") {
              // ah =  w.innerHeight * 0.5;
              maxH = style === "None" ? maxH : maxH * 0.9;
              maxW = style === "None" ? maxW : maxW * 0.9;
              let avaible = w.innerHeight - parseFloat(w.getComputedStyle(S$Q(".dp_epu-footer")).height) - 50;
              maxH = Math.min(maxH, avaible);

              const maxWidth = w.innerWidth * 0.8;
              if (aw > maxWidth) {
                  aw = maxWidth;
                  ah = (hi / wi) * aw;
                  ab = (bi / hi) * ah;
              }
        }


        // Calculate maximum dimensions
        const { maxFrameHeight, maxFrameWidth } = this.getWstAndTstFrameD([frame]);
        const { maxHeight, maxWidth } = w.dType === "M" ? { maxHeight: maxH , maxWidth:  maxW } : { maxHeight: ah, maxWidth: aw };

        cLog(`📱 Device type: ${w.dType}, Max dimensions: ${maxWidth}x${maxHeight}`);

        // Calculate scaling ratios
        const hr = maxFrameHeight / maxHeight;
        const wr = maxFrameWidth / maxWidth;
        const a2c = hr > wr ? "h" : "w";

        await this.updateFrameSize(frame, maxFrameHeight, maxHeight, maxFrameWidth, maxWidth, a2c, "styles", i2s);

        
        // Update global size reference
        Cnvs.Popup.update({
          ceStyle: style 
        });

        return true;
      } catch (error) {
        console.error("❌ Error in updateSingleFrameStyle:", error);
        return false;
      }
    },

    /**
     * Update border for a single frame in the edit popup
     * @param {HTMLElement} el - Border selection element
     * @returns {boolean} - Success status
     */
    async updateSingleFrameEdge(edge) {
      try {
        const pu = Cnvs.Popup.current;
        if (!pu.isOpen || !pu.ceF) {
          console.warn("⚠️ Popup state not available for border update");
          return false;
        }

        if (edge === pu.ceF.dataset.frameEdge) {
          console.error(`⚠️ same edge type: ${edge}`);
          return false;
        }

        pu.SoBchanged = true;
        const prevEdge = pu.ceF.dataset.frameEdge || "Wrapped";
        const { ab, borderPx, newTop, newLeft, NEWceSc } = this.applyFrameBorderLogic(pu.ceF, edge, pu.ceScale);
        // Apply new padding (border mat)
        pu.ceF.dataset.borderPx = borderPx;

        // Update popup state
        Cnvs.Popup.update({
          ceEdge: edge
        });

        if (prevEdge === "Wrapped" || edge === "Wrapped") {
           Cnvs.Popup.update({
            ceScale: NEWceSc,
            ceLeft: newLeft,
            ceTop: newTop,
          });
          await this.sizeAdjustPosition({frame: pu.ceF, Ra4Sc: 1, newLeft, newTop, newScale: NEWceSc});
        } 
        // Adjust position and save changes
        Cnvs?.State?.scheduleSave();

        return true;
      } catch (error) {
        console.error("❌ Error in updateSingleFrameBorder:", error);
        return false;
      }
    },

    calcalulateFrameInPx(frame, maxFrameHeight, maxHeight, maxFrameWidth, maxWidth, a2c,) {
      if (frame.querySelectorAll(".img-box").length > 0) {
        var ceB = frame.querySelector(".img-box");
        var ceI = frame.querySelector(".img-box img");
        var oldBW = ceB.clientWidth;
        var oldBH = ceB.clientHeight;
        const natW = ceI.naturalWidth;
        const natH = ceI.naturalHeight;

        const CLeft = ceI.offsetLeft;
        const CTop = ceI.offsetTop;

        const elWCe = (natW - oldBW) / 2;
        const elHCe = (natH - oldBH) / 2;

        var bigLeft = -elWCe;
        var bigTop = -elHCe;

        var oldWdiFC = CLeft - bigLeft;
        var oldHdiFC = CTop - bigTop;
      }
      const borderInInches = 0.9;
      const bII =
        frame.dataset.frameBorder == "No Mat"
          ? 0
          : frame.dataset.frameBorder == "Standard"
            ? 0.1
            : 0.2;
      const widthInInches = parseInt(
        frame.getAttribute("data-width-in-inches"),
        10
      );
      const heightInInches = parseInt(
        frame.getAttribute("data-height-in-inches"),
        10
      );
      const heightRatio = heightInInches / maxFrameHeight;
      const widthRatio = widthInInches / maxFrameWidth;
      var Ra4Sc = heightRatio;
      const frameWidth = parseFloat(frame.style.width);
      if (a2c == "h") {
        var adjustedHeight = heightRatio * maxHeight;
        var adjustedWidth = (widthInInches / heightInInches) * adjustedHeight;
        if (adjustedWidth > maxWidth) {
          const widthRatio = maxWidth / adjustedWidth;
          adjustedWidth = maxWidth;
          adjustedHeight *= widthRatio;
        }
      } else {
        Ra4Sc = widthRatio;
        var adjustedWidth = widthRatio * maxWidth;
        var adjustedHeight = (heightInInches / widthInInches) * adjustedWidth;
        if (adjustedHeight > maxHeight) {
          const heightRatio = maxHeight / adjustedHeight;
          adjustedHeight = maxHeight;
          adjustedWidth *= heightRatio;
        }
      }

      const s4c =
        widthInInches > heightInInches ? heightInInches : widthInInches;
      const adjustedBorder = (borderInInches / heightInInches) * adjustedHeight;
      const adjustedMat = ((s4c * bII) / heightInInches) * adjustedHeight;
      const PXwidthRatio = adjustedWidth / frameWidth;
      return {
        adjustedWidth,
        adjustedHeight
      }
    },
    getMaxFrameSizeConsideringNewSize(frames, currentFrameId, newSize) {
      let maxFrameWidth = 0;
      let maxFrameHeight = 0;

      frames.forEach((frame) => {
        const frameId = frame.dataset.frameId;

        let width, height;

        if (frameId === currentFrameId && newSize) {
          [width, height] = newSize.split("x").map(parseFloat);
        } else {
          width = parseFloat(frame.getAttribute("data-width-in-inches")) || 0;
          height = parseFloat(frame.getAttribute("data-height-in-inches")) || 0;
        }

        if (width > maxFrameWidth) maxFrameWidth = width;
        if (height > maxFrameHeight) maxFrameHeight = height;
      });

      return { maxFrameWidth, maxFrameHeight };
    },

    computeFrameSizeInPixels(frame, newSize, pu) {
      try {
        // Get frames and validate
        const frames = S$$(".frame");
        const currentFrameId = frame.dataset.frameId;

        const { maxFrameWidth, maxFrameHeight } = this.getMaxFrameSizeConsideringNewSize(
          frames,
          currentFrameId,
          newSize
        );

        const { maxHeight, maxWidth } =
          w.dType === "M"
            ? {
              maxHeight:
                (w?.Cnvs?.Main?.ui?.galHeight || Cnvs?.Main?.ui?.galHeight || w.innerHeight - 160) * 0.8,
              maxWidth: w.innerWidth * 0.8,
            }
            : { maxHeight: 400, maxWidth: 400 };


        // Calculate scaling ratios
        const hr = maxFrameHeight / maxHeight;
        const wr = maxFrameWidth / maxWidth;
        const a2c = hr > wr ? "h" : "w";

        const { adjustedWidth, adjustedHeight } = this.calcalulateFrameInPx(pu.cuF,
          maxFrameHeight,
          maxHeight,
          maxFrameWidth,
          maxWidth,
          a2c,)

        return {
          width: adjustedWidth,
          height: adjustedHeight
        };

      } catch (error) {
        console.error("❌ Error in calculateNewFrameDimensions:", error);
        return { width: 0, height: 0, contentWidth: 0, contentHeight: 0, padding: 0 };
      }
    },

    /**
     * End single frame edit mode
     * @returns {boolean} - Success status
     */
    async endSEdit() {
      cLog("🔚 Cnvs.Frames: Ending single frame edit");
      try {
        S$$(".frame").forEach(f => f.classList.add("no-transition-end"));
        var epopup = S$Q(".dp_epu");
        const { maxHeight, maxWidth } =
          w.dType === "M"
            ? {
              maxHeight:
                (w.Cnvs.Main.ui.galHeight || w.innerHeight - 160) * 0.8,
              maxWidth: w.innerWidth * 0.8,
            }
            : { maxHeight: 400, maxWidth: 400 };
        // Get popup state
        const pu = Cnvs.Popup.current;
        if (!pu.ceI.style.left) {
          pu.ceI.style.left = pu.ceI.offsetLeft + "px";
        }
        if (!pu.ceI.style.top) {
          pu.ceI.style.top = pu.ceI.offsetTop + "px";
        }
        epopup.querySelector(".dp_epu-box").style.overflow = "visible";
        this.createCloneForAnimation();

        pu.ceLeft = parseFloat(pu.ceI.style.left || pu.ceI.offsetLeft);
        pu.ceTop = parseFloat(pu.ceI.style.top || pu.ceI.offsetTop);

        pu.ceScale = parseFloat(Cnvs.Utils.getScale(pu.ceI))
        // Check if size was changed
        if (pu.ceSize != pu.cuSize) {
          var i2s = epopup.dataset.editIndex;
          pu.cuF.setAttribute("data-width-in-inches", pu.ceSize.split("x")[0]);
          pu.cuF.setAttribute("data-height-in-inches", pu.ceSize.split("x")[1]);
          pu.cuF.dataset.vid = pu.ceF.dataset.vid;
          pu.cuF.dataset.framePrice = pu.ceF.dataset.framePrice;
          pu.cuF.parentElement.querySelector(
            ".finfo_price"
          ).innerText = `$${pu.ceF.dataset.framePrice}`;
          // Cnvs.Frames.updateFrameSizes("size", i2s);

          const widthInInches = parseInt(
            pu.cuF.getAttribute("data-width-in-inches"),
            10
          );
          const heightInInches = parseInt(
            pu.cuF.getAttribute("data-height-in-inches"),
            10
          );
          let widthPx, heightPx, scp;
          const ratio = widthInInches / heightInInches;
          if (maxWidth / maxHeight > ratio) {
            heightPx = maxHeight;
            widthPx = maxHeight * ratio;
          } else {
            widthPx = maxWidth;
            heightPx = maxWidth / ratio;
          }
          scp = heightPx / parseFloat(pu.ceF.style.height);

          this?.renderFrameWithEdgeFromData({
            frame: pu.cuF,
            parsedMainFrame: {
              frameHeight: parseFloat(pu.ceF.style.height),
              frameWidth: parseFloat(pu.ceF.style.width),
              borderWidth: parseFloat(pu.ceF.style.borderWidth),
              padding: parseFloat(pu.ceF.style.padding),
              scale: parseFloat(Cnvs.Utils.getScale(pu.ceI)),
              top: parseFloat(pu.ceI.style.top),
              left: parseFloat(pu.ceI.style.left),
            },
            widthPx,
            heightPx,
            scaleCorrection: scp
          });
          console.log(
            pu.ceSize,
            pu.ceSize.split("x")[0] < pu.ceSize.split("x")[1] ? pu.ceSize.split("x")[0] + "x" + pu.ceSize.split("x")[1] : pu.ceSize.split("x")[1] + "x" + pu.ceSize.split("x")[0]
          );

          const frameId = pu.cuF.dataset.frameId;
          if (frameId) {
            this.updateFrameCssStyles(frameId, {
              padding: (parseFloat(pu.ceF.style.padding) * scp) + "px",
              borderWidth: (parseFloat(pu.ceF.style.borderWidth) * scp) + "px",
              height: heightPx + "px",
              width: widthPx + "px",
            });
          }

          await Cnvs.Frames._updateFrameSizesImmediate("size");

          Cnvs.State.updateFrame(pu.cuF.dataset.frameId, {
            size: {
              size: pu.ceSize,
              variant: pu.ceSize.split("x")[0] < pu.ceSize.split("x")[1] ? pu.ceSize.split("x")[0] + "x" + pu.ceSize.split("x")[1] : pu.ceSize.split("x")[1] + "x" + pu.ceSize.split("x")[0],
              width: pu.ceSize.split("x")[0],
              height: pu.ceSize.split("x")[1],
            },
            variantID: pu.ceF.dataset.vid,
          });
        }
        // Check if scale or position was changed using popup state
        else if (pu.SoPchanged === true) {
          cLog("📐 Applying scale/position changes from edit popup");
          this.AESnP();
          Cnvs.Popup.update({ SoPchanged: false });
        }

        if (pu.soBWchanged === true) {
          console.log("📐 Applying black and white changes from edit popup");
          // pu.cuI.style.filter = pu.ceI.style.filter;
         const frameContainer = pu.cuF?.closest(".frame_container");

          if (frameContainer) frameContainer.classList.toggle("dp_bw-ao", !!pu.cuBW);
          pu.cuF.dataset.frameBw = pu.cuBW.toString();
          Cnvs.Popup.update({ soBWchanged: false });
          Cnvs.State.updateFrame(pu.cuF.dataset.frameId, {
            bw: pu.cuBW,
          });
        }

        if (pu.SoBchanged || pu.ceF.dataset.frameEdge != pu.cuF.dataset.frameEdge) {
          pu.cuF.dataset.frameEdge = pu.ceF.dataset.frameEdge;

          const widthInInches = parseInt(pu.cuF.getAttribute("data-width-in-inches"),10);
          const heightInInches = parseInt(pu.cuF.getAttribute("data-height-in-inches"),10);
          let widthPx, heightPx, scp;
          const ratio = widthInInches / heightInInches;
          // if (maxWidth / maxHeight > ratio) {
          //   heightPx = maxHeight;
          //   widthPx = maxHeight * ratio;
          // } else {
          //   widthPx = maxWidth;
          //   heightPx = maxWidth / ratio;
          // }
          // scp = heightPx / parseFloat(pu.ceF.style.height);
          widthPx = parseFloat(pu.cuF.style.width);
          heightPx = parseFloat(pu.cuF.style.height);
          scp = heightPx / parseFloat(pu.ceF.style.height);

          this?.renderFrameWithEdgeFromData({
            frame: pu.cuF,
            parsedMainFrame: {
              frameHeight: parseFloat(pu.ceF.style.height),
              frameWidth: parseFloat(pu.ceF.style.width),
              borderWidth: parseFloat(pu.ceF.style.borderWidth),
              padding: parseFloat(pu.ceF.style.padding),
              scale: parseFloat(Cnvs.Utils.getScale(pu.ceI)),
              top: parseFloat(pu.ceI.style.top),
              left: parseFloat(pu.ceI.style.left),
            },
            widthPx,
            heightPx,
            scaleCorrection: scp
          });

          await Cnvs.Frames._updateFrameSizesImmediate("size");

          Cnvs.State.updateFrame(pu.cuF.dataset.frameId, {
            size: {
              size: pu.ceSize,
              variant: pu.ceSize.split("x")[0] < pu.ceSize.split("x")[1] ? pu.ceSize.split("x")[0] + "x" + pu.ceSize.split("x")[1] : pu.ceSize.split("x")[1] + "x" + pu.ceSize.split("x")[0],
              width: pu.ceSize.split("x")[0],
              height: pu.ceSize.split("x")[1],
            },
            variantID: pu.ceF.dataset.vid,
          });
          
          // Update cssStyles when padding changes
          const frameId = pu.cuF.dataset.frameId;
          if (frameId) {
            this.updateFrameCssStyles(frameId, {
              padding: (parseFloat(pu.ceF.style.padding) * scp) + "px",
              borderWidth: (parseFloat(pu.ceF.style.borderWidth) * scp) + "px",
              height: heightPx + "px",
              width: widthPx + "px",
            });
          }

          // Cnvs.Frames.sizeAdjustPosition(pu.cuF);
          Cnvs.State.updateFrame(pu.cuF.dataset.frameId, {
            border: pu.ceF.dataset.frameBorder,
            borderPx: parseFloat(pu.ceF.style.padding || 0) * (1 / Cnvs.Utils.getScale(pu.ceI)),
          });

          Cnvs.Frames.updateFrameSizes("styles");
        }

        Cnvs.State.updateFrame(pu.cuF.dataset.frameId, {
          border: pu.ceF.dataset.frameBorder,
          edge: pu.ceF.dataset.frameEdge,
        });

        if (pu.ceF.dataset.frameStyle !== pu.cuF.dataset.frameStyle) {
          let [w, h] = [
            pu.ceF.dataset.widthInInches,
            pu.ceF.dataset.heightInInches,
          ].sort((a, b) => a - b);
          const style4Search = pu.ceF.dataset.frameStyle === 'None' ? 'Wrapped_Canvas' : pu.ceF.dataset.frameStyle;
          pu.cuF.dataset.vid = pu.ceF.dataset.vid;
          pu.cuF.dataset.frameStyle = pu.ceF.dataset.frameStyle
          const vid = Cnvs?.Utils?.findPByKey(`${style4Search}__${w}x${h}`).id;
          Object.assign(pu.cuF.dataset, {
            vid: vid,
            frameStyle: pu.ceF.dataset.frameStyle,
          });
          Cnvs.State.updateFrame(pu.cuF.dataset.frameId, {
            style: pu.ceF.dataset.frameStyle,
            variantID: vid,
          });
          
          await Cnvs.Frames._updateFrameSizesImmediate("styles");
        }

        // Get current frame to preserve existing image data
        const currentFrame = Cnvs.State.getFrame(pu.cuF.dataset.frameId);
        if (currentFrame?.image) {
          pu.cuF.dataset.framePrice = pu.ceF.dataset.framePrice;
          pu.cuF.parentElement.querySelector(".finfo_price").innerText = `$${pu.ceF.dataset.framePrice}`;
          Cnvs.State.updateFrame(pu.cuF.dataset.frameId, {
            image: {
              ...currentFrame.image,  // Preserve all existing image properties
              scale: pu.cuI.dataset.scale  // Only update the scale
            },
            price: parseFloat(pu.ceF.dataset.framePrice),
          });
        }

        // S$Q(".dp_epu").style.display = "none";
        // S$Q(".dp_epu").style.opacity = 0;
        
        // S$Q(".dp_epu-body").innerHTML = "";

        const frameId = pu.cuF.dataset.frameId;
        if (frameId) {
          pu.cuF.offsetHeight; // Force reflow for transition
          this.updateFrameCssStyles(frameId, {
            borderWidth: (parseFloat(pu.cuF.style.borderWidth)) + "px",
            height: (parseFloat(pu.cuF.style.height)) + "px",
            width: (parseFloat(pu.cuF.style.width)) + "px",
          });
        }

        if((pu.ceSize != pu.cuSize) || (pu.SoBchanged || pu.ceF.dataset.frameEdge != pu.cuF.dataset.frameEdge) || pu.soBWchanged === true || pu.soBchanged === true){
          this.sizeAdjustPosition({frame: pu.cuF, Ra4Sc: 1,  action: "PageLoad"})
        }
        

        // Update cart summary
        Cnvs?.Cart?.buildFramesSummary();

        // Save to database
        Cnvs?.State?.scheduleSave();
        S$$(".frame").forEach(f => f.classList.remove("no-transition-end"));
        setTimeout(()=>{
          // S$Q(".dp_epu").style.display = "none";
          // S$Q(".dp_epu").style.opacity = 1;
          S$$(".frame").forEach(f => f.classList.remove("no-transition-end"));
          // Check PPI for all frames
          Cnvs.Frames.checkPPI();
        }, 1000);
        
        this.closePopupAnimation();

        return true;
      } catch (error) {
        console.error("❌ Error in endSEdit:", error);
        Cnvs.Popup.current.isOpen = false;
        Cnvs.Popup.current.cuF.style.opacity = "1";
        Cnvs.State.closePopup();

        setTimeout(()=>{
          // S$Q(".dp_epu").style.display = "none";
          // S$Q(".dp_epu").style.opacity = 1;
          S$$(".frame").forEach(f => f.classList.remove("no-transition-end"));
        }, 1000);
        this.closePopupAnimation();
        return false;
      }
    },
    frameHTML(frame) {
      return `
        <div class="frame_container swiper-slide frame_hidden ${frame.acrylic ? " dp_acr-ao" : ""} ${frame.bw ? " dp_bw-ao" : ""
        }">
          <div class="finfo">
            <div class="finfo_price">$${frame.price}</div>
            <div class="finfo_acrBox">
              <div class="finfo_acrI"></div>
              <div class="finfo_acrTT"></div>
            </div>
          </div>
          <div class="frame framefh" data-vid="${frame.variantID}" data-frame-id="${frame.id}" data-width-in-inches="${frame.size.width}" data-height-in-inches="${frame.size.height}" data-frame-style="${frame.style}" data-frame-edge="${frame.edge}" data-border-px="0" data-frame-bw="${frame.bw}" data-image="" style="height: ${frame.cssStyles?.height || '200px'}; width: ${frame.cssStyles?.width || '160px'}; border-width: ${frame.cssStyles?.borderWidth || '2px'}; --frame-size: ${frame.cssStyles?.borderWidth || '28.6667px'}">
            <div class="img-wrapper">
              <div class="img-print">
                <div class="img-box">
                  <img data-scale="${frame.image?.scale ?? 'min'}" src="${frame.image?.previewURL}" class="img-preview-thumb" style="opacity: 0; ${frame.image?.imgStyles || ''}">
                </div>
              </div>
            </div>
            <span class="dp_eb"></span>
            <span class="dp_cb"></span>
            <span class="dp_rb"></span>
            <span class="dp_lr"><b>!</b> &nbsp;&nbsp; Low Resolution</span>
          </div>
        </div>
      `;
    },

    getFramePropertiesById(id) {
      try {
        const frameEl = document.querySelector(`[data-frame-id="${id}"]`);
        if (!frameEl) return {};

        const frameHeight = parseFloat(getComputedStyle(frameEl).height);
        const frameWidth = parseFloat(getComputedStyle(frameEl).width);
        const borderWidth = parseFloat(getComputedStyle(frameEl).borderWidth);
        const padding = parseFloat(getComputedStyle(frameEl).padding);

        const imgEl = frameEl.querySelector('.img-box img');
        if (!imgEl) return {};

        const transform = getComputedStyle(imgEl).transform;
        const match = transform.match(/matrix\((.+?)\)/);
        const scale = match ? parseFloat(match[1].split(',')[0]) : 1;

        const top = parseFloat(getComputedStyle(imgEl).top) || imgEl.offsetTop || 0;
        const left = parseFloat(getComputedStyle(imgEl).left) || imgEl.offsetLeft || 0;
        const dataScale = imgEl.dataset.scale || "min";

        return {
          frameHeight,
          frameWidth,
          borderWidth,
          padding,
          scale,
          top,
          left,
          dataScale
        };
      } catch (err) {
        console.warn("⚠️ Could not extract mainFrameProperties:", err);
        return {};
      }
    },

    renderFrameWithEdgeFromData({
            frame,
            parsedMainFrame,
            widthPx,
            heightPx,
            scaleCorrection,
            applyImgBoxTransform = true
        }) {
          const {
              borderWidth,
              padding,
              scale,
              left,
              top,
              dataScale,
          } = parsedMainFrame;
          const widthInInches = frame.dataset.widthInInches;
          const heightInInches = frame.dataset.heightInInches;
          const frameStyle = frame.dataset.frameStyle;
          const frameEdge = frame.dataset?.frameStyle == "None" ? "Wrapped" : frame.dataset.frameStyle;
          const border = frameEdge;

          // --- Frame basic dimension reconstruction ---
          frame.style.width = `${widthPx}px`;
          frame.style.height = `${heightPx}px`;

          // Reapply frame style-based logic
          const borderInInches = 1.25;
          const bII = frameEdge === "black" || frameEdge === "white" ? 1.5 : 0;
          const s4c = widthInInches > heightInInches ? heightInInches : widthInInches;
          let adjustedBorder = ((borderInInches / heightInInches) * heightPx) * 1 / scaleCorrection;
          let adjustedMat = ((s4c * bII) / heightInInches) * heightPx;
          const frameWidth = parseFloat(frame.style.width);
          let adjustedWidth = widthPx;
          let adjustedHeight = heightPx;
          const PXwidthRatio = adjustedWidth / frameWidth;
          // Calculate border padding
          const imgBox = frame.querySelector(".img-box");
          const img = frame.querySelector(".img-box img");

          if (frame.dataset.frameStyle == "None") {
              const sidePx = this.sidePixels(widthInInches, adjustedWidth, borderInInches);
              frame.style.height = `${adjustedHeight + sidePx}px`;
              frame.style.width = `${adjustedWidth + sidePx}px`;
              frame.style.setProperty('--p-hinches', `${heightInInches}`);
              frame.style.setProperty('--p-winches', `${widthInInches}`);
              frame.style.setProperty('--w-height', `${adjustedHeight + sidePx}px`);
              frame.style.setProperty('--w-width', `${adjustedWidth + sidePx}px`);
              frame.style.setProperty('--b-height', `${adjustedHeight}px`);
              frame.style.setProperty('--b-width', `${adjustedWidth}px`);
              adjustedBorder = 0;
          } else {
              frame.style.height = `${adjustedHeight}px`;
              frame.style.width = `${adjustedWidth}px`;
              frame.style.setProperty('--p-hinches', `${heightInInches}`);
              frame.style.setProperty('--p-winches', `${widthInInches}`);
              frame.style.setProperty('--w-height', `${adjustedHeight}px`);
              frame.style.setProperty('--w-width', `${adjustedWidth}px`);
              frame.style.setProperty('--b-height', `${adjustedHeight}px`);
              frame.style.setProperty('--b-width', `${adjustedWidth}px`);
          }
          frame.style.borderWidth = `${adjustedBorder}px`;
          frame.style.setProperty('--frame-size', `${adjustedBorder}px`);
          // frame.style.padding = `${adjustedMat}px`;

          if (!img) return;

          if (applyImgBoxTransform) {
              img.style.transform = `scale(${scale * scaleCorrection})`;
          }

          const pu = Cnvs.Popup.current;;
          pu.ceNW = img.naturalWidth;
          pu.ceNH = img.naturalHeight;

          // Recalculate offsets
          const mainScaleDifference = 1 - scale;
          const mainNaturalWidthXScaleDifference = (pu.ceNW * mainScaleDifference) / 2;
          const mainNaturalHeightXScaleDifference = (pu.ceNH * mainScaleDifference) / 2;

          const newScale = scale * scaleCorrection;
          const popupScaleDifference = 1 - newScale;
          const popupNaturalWidthXScaleDifference = (pu.ceNW * popupScaleDifference) / 2;
          const popupNaturalHeightXScaleDifference = (pu.ceNH * popupScaleDifference) / 2;

          const popupwdis = mainNaturalWidthXScaleDifference + parseFloat(left);
          const popuphdis = mainNaturalHeightXScaleDifference + parseFloat(top);

          const mainwdis = (popupwdis / scale) * newScale;
          const mainhdis = (popuphdis / scale) * newScale;

          const bigLeft = -popupNaturalWidthXScaleDifference + mainwdis;
          const bigTop = -popupNaturalHeightXScaleDifference + mainhdis;

          img.style.left = `${bigLeft}px`;
          img.style.top = `${bigTop}px`;
          // this.sizeAdjustPosition({ frame, Ra4Sc: 1, action: "onload" });
      },

    renderFrameFromData({
      frame,
      parsedMainFrame,
      widthPx,
      heightPx,
      scaleCorrection,
      applyImgBoxTransform = true
    }) {

      const {
        borderWidth,
        padding,
        scale,
        left,
        top,
        dataScale
      } = parsedMainFrame;

      frame.style.width = `${widthPx}px`;
      frame.style.height = `${heightPx}px`;
      frame.style.padding = `${padding * scaleCorrection}px`;
      frame.style.borderWidth = `${borderWidth * scaleCorrection}px`;
      frame.style.frameSize = `${borderWidth * scaleCorrection}px`;

      const img = frame.querySelector(".img-box img");
      if (applyImgBoxTransform) {
        img.style.transform = `scale(${scale * scaleCorrection})`;
      }

      const pu = Cnvs.Popup.current;
      pu.ceNW = img.naturalWidth;
      pu.ceNH = img.naturalHeight;

      const mainScaleDifference = 1 - scale;
      const mainNaturalWidthXScaleDifference = (pu.ceNW * mainScaleDifference) / 2;
      const mainNaturalHeightXScaleDifference = (pu.ceNH * mainScaleDifference) / 2;

      const newScale = scale * scaleCorrection;
      const popupScaleDifference = 1 - newScale;
      const popupNaturalWidthXScaleDifference = (pu.ceNW * popupScaleDifference) / 2;
      const popupNaturalHeightXScaleDifference = (pu.ceNH * popupScaleDifference) / 2;

      const popupwdis = mainNaturalWidthXScaleDifference + parseFloat(left);
      const popuphdis = mainNaturalHeightXScaleDifference + parseFloat(top);

      const mainwdis = (popupwdis / scale) * newScale;
      const mainhdis = (popuphdis / scale) * newScale;

      const bigLeft = -popupNaturalWidthXScaleDifference + mainwdis;
      const bigTop = -popupNaturalHeightXScaleDifference + mainhdis;

      img.style.left = `${bigLeft}px`;
      img.style.top = `${bigTop}px`;

      this.sizeAdjustPosition({ frame, Ra4Sc: 1, action: "onload" });
    },

    getInlineTransformValues(element) {
      const transform = element.style.transform;

      if (!transform || transform === "none") {
        return {
          scale: 1,
          rotate: 0,
          translateX: 0,
          translateY: 0,
          raw: 'none'
        };
      }

      const values = {
        scale: 1,
        rotate: 0,
        translateX: 0,
        translateY: 0,
        raw: transform
      };

      // Match scale
      const scaleMatch = transform.match(/scale\(([^)]+)\)/);
      if (scaleMatch) {
        values.scale = parseFloat(scaleMatch[1]);
      }

      // Match translate
      const translateMatch = transform.match(/translate\(([^,]+),\s*([^)]+)\)/);
      if (translateMatch) {
        values.translateX = parseFloat(translateMatch[1]);
        values.translateY = parseFloat(translateMatch[2]);
      }

      // Match rotate
      const rotateMatch = transform.match(/rotate\(([^)]+)deg\)/);
      if (rotateMatch) {
        values.rotate = parseFloat(rotateMatch[1]);
      }

      return values;
    },


    applyFrameBorderLogic(frameEl, border, currentScale) {
      frameEl.classList.add("no-transition");
      const imgBox = border == "Wrapped" ? frameEl.querySelector(".img-print") : frameEl.querySelector(".img-box");
      const img = frameEl.querySelector(".img-box img");
      const oldPadding = parseFloat(frameEl.style.padding || 0);
      const widthInches = parseFloat(frameEl.dataset.widthInInches);
      const heightInches = parseFloat(frameEl.dataset.heightInInches);

      if (isNaN(widthInches) || isNaN(heightInches)) return void cWarn(`⚠️ Invalid dimensions for frame ${frameEl.dataset.frameId}`);

      // Calculate border padding
      const boxWidth = parseFloat(getComputedStyle(imgBox).width);
      const boxHeight = parseFloat(getComputedStyle(imgBox).height);
      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;
      const incToPxRatio = boxWidth / widthInches;
      const borderInches = border === "Wrapped" ? 0 : 1.5;
      const borderPx = borderInches * incToPxRatio;

      frameEl.dataset.frameEdge = border;
      frameEl.dataset.borderPx = borderPx;
      if (frameEl.dataset.frameId) this.updateFrameCssStyles(frameEl.dataset.frameId, {padding: `${0}px`,});

      const minScaleX = boxWidth / naturalWidth;
      const minScaleY = boxHeight / naturalHeight;
      
      const scaleCorrection = border == "Wrapped" ? 1 : 1;
      const minScale = Math.max(minScaleX, minScaleY) * scaleCorrection;
      const NEWceSc = Math.max(currentScale, minScale);

      // img.style.transform = `scale(${NEWceSc})`;

      const borderDiff = borderPx - oldPadding;
      let newLeft = parseFloat(img.style.left || img.offsetLeft);
      let newTop = parseFloat(img.style.top || img.offsetTop);

      return { borderPx, newTop, newLeft, NEWceSc };
    },

    /**
     * Handle checkbox change for acrylic settings (both global and single frame)
     * @param {Event} event - Checkbox change event
     * @returns {boolean} - Success status
     */
    handleCheckboxChange(event) {
      cLog("🔲 Cnvs.Frames: Handling checkbox change");

      try {
        const checkbox = event.target;
        if (!checkbox) {
          console.error("❌ Invalid checkbox element");
          return false;
        }

        const isChecked = checkbox.checked;
        const isGlobalAcrylic = checkbox.id === "vpacr";

        cLog(
          `🎨 ${isGlobalAcrylic ? "Global" : "Single"} acrylic: ${isChecked ? "ON" : "OFF"
          }`
        );

        // Handle global acrylic change
        if (isGlobalAcrylic) {
          const applyChange = () => {
            const frames = S$$(".frame_container");
            let updatedCount = 0;

            // Update centralized state first when changes are getting applied
            Cnvs?.State?.updateAcrylic(isChecked);

            frames.forEach((frame, index) => {
              try {
                // Update CSS class
                if (isChecked) {
                  frame.classList.add("dp_acr-ao");
                } else {
                  frame.classList.remove("dp_acr-ao");
                }

                // Update data attribute
                const frameEl = frame.querySelector(".framefh");
                if (frameEl) {
                  frameEl.dataset.frameAcrylic = isChecked.toString();
                }

                // Update state if frame exists in state
                const appState = Cnvs?.State?.getState();
                if (appState?.frames?.length > index) {
                  Cnvs?.State?.updateFrame(appState.frames[index].id, {
                    acrylic: isChecked,
                  });
                }

                updatedCount++;
              } catch (frameError) {
                console.error(`❌ Error updating frame ${index}:`, frameError);
              }
            });

            cLog(`✅ Updated acrylic for ${updatedCount} frames`);
          };

          // Check if all frames have consistent settings
          const checkFC = Cnvs?.Utils?.checkFrameConsistency || (() => true);
          if (checkFC("acrylic")) {
            applyChange();
          } else {
            S$G("fpcp").style.display = "block";
            S$G("background-overlay").style.display = "block";
            S$Q(".fpcpApply").addEventListener(
              "click",
              function () {
                applyChange();
                if (typeof w.Cnvs.Cart?.buildFramesSummary === "function") {
                  w.Cnvs.Cart?.buildFramesSummary();
                }
                S$G("fpcp").style.display = "none";
                S$G("background-overlay").style.display = "none";
              },
              { once: true }
            );
            S$Q(".fpcpDiscard").addEventListener(
              "click",
              function () {
                S$G("fpcp").style.display = "none";
                S$G("background-overlay").style.display = "none";
                checkbox.checked = !isChecked;
              },
              { once: true }
            );
          }
        } else {
          // Handle single frame acrylic change (edit popup)
          try {
            const epopup = S$Q(".dp_epu");
            const frameIndex = epopup?.dataset.editIndex;

            if (!frameIndex) {
              console.error("❌ No frame index found for edit popup");
              return false;
            }

            const frameContainer = S$Q(
              `.img-thumbs .frame[data-frame-index="${frameIndex}"]`
            )?.parentElement;
            if (!frameContainer) {
              console.error(
                `❌ Frame container not found for index: ${frameIndex}`
              );
              return false;
            }

            // Update single frame
            if (isChecked) {
              frameContainer.classList.add("dp_acr-ao");
            } else {
              frameContainer.classList.remove("dp_acr-ao");
            }

            const frameEl = frameContainer.querySelector(".framefh");
            if (frameEl) {
              frameEl.dataset.frameAcrylic = isChecked.toString();
            }

            // Update state for this specific frame
            const state = Cnvs?.State?.getState();
            const { frames } = state;
            const indexFrame = frames.findIndex(
              (f) => f.positionIndex === parseInt(frameIndex)
            );
            const frameId = state.frames?.[indexFrame]?.id;
            if (frameId) {
              Cnvs?.State?.updateFrame(frameId, { acrylic: isChecked });
            }

            cLog(`✅ Updated single frame acrylic: ${isChecked}`);
          } catch (singleFrameError) {
            console.error(
              "❌ Error updating single frame acrylic:",
              singleFrameError
            );
          }
        }

        // Trigger summary update and save
        if (typeof w.Cnvs.Cart?.buildFramesSummary === "function") {
          w.Cnvs.Cart?.buildFramesSummary();
        }

        // Auto-save to database
        Cnvs?.State?.scheduleSave();

        return true;
      } catch (error) {
        console.error("❌ Error in Cnvs.Frames.handleCheckboxChange:", error);
        Cnvs?.State?.setError("acrylic", error.message);
        return false;
      }
    },
    
    frameState: {
      scale: 1,
      startDist: 0,
      originX: 50,
      originY: 50,
      MIN: 1,
      MAX: 4,
      activeFrame: null,
      
      translateX: 0,
      translateY: 0,
      startMidX: 0,
      startMidY: 0,
    },

    setTransform(el) {
      el.style.transform = `translate(${Cnvs.Frames.frameState.translateX}px,${Cnvs.Frames.frameState.translateY}px)
        scale(${Cnvs.Frames.frameState.scale})`;
      el.style.transformOrigin = `${Cnvs.Frames.frameState.originX}% ${Cnvs.Frames.frameState.originY}%`;
    },

    getFrameElement(target) {
      // dynamically find the frame element
      if (target.classList.contains("framefh")) return target;
      return target.closest(".framefh");
    },

    touchStart(e) {
      if (e.touches.length !== 2) return;

      if (e.cancelable) e.preventDefault();

      S$Q(".frames_swiper").style.overflow = "unset";
      S$Q(".dp_main").style.zIndex = "999999";

      let frame = Cnvs.Frames.getFrameElement(e.target);
      if (!frame) {
        if (e.target.classList?.contains('frame')) {
          frame = e.target;
        } else {
          frame = e.target.closest?.('.frame');
        }
      }

      if (!frame) return;

      // Disable ALL transitions during pinch
      frame.classList.add("no-transition", "zooming");
      frame.closest(".frame_container").classList.add("zooming");

      S$Q("body").classList.add("body-lock");
      S$Q(".dp_wrapper").style.zIndex = 1;
      S$Q(".dp_fub.mo").style.display = "none";

      const finfo = frame.closest(".frame_container")?.querySelector(".finfo");
      if (finfo) finfo.style.display = "none";

      const dpEb = frame.querySelector(".dp_eb");
      if (dpEb) dpEb.style.display = "none";
      
      const container = frame.closest(".frame_container");
      if (container) container.style.zIndex = "2";

      // store frame reference ONCE
      Cnvs.Frames.frameState.activeFrame = frame;

      Cnvs.Frames.frameState.startDist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );

      const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

      Cnvs.Frames.frameState.startMidX = midX;
      Cnvs.Frames.frameState.startMidY = midY;

      const rect = frame.getBoundingClientRect();
      Cnvs.Frames.frameState.originX =
        (((e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left) / rect.width) * 100;
      Cnvs.Frames.frameState.originY =
        (((e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top) / rect.height) * 100;

      // Attach move & end globally
      document.addEventListener("touchmove", Cnvs.Frames.touchMove, { passive: false });
      document.addEventListener("touchend", Cnvs.Frames.touchEnd);
      document.addEventListener("touchcancel", Cnvs.Frames.touchEnd);
    },

    touchMove(e) {
      if (e.touches.length !== 2) return;
      if (e.cancelable) e.preventDefault();

      const frame = Cnvs.Frames.frameState.activeFrame;
      if (!frame) return;

      const newDist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );

      Cnvs.Frames.frameState.scale *= newDist / Cnvs.Frames.frameState.startDist;
      Cnvs.Frames.frameState.scale = Math.min(
        Cnvs.Frames.frameState.MAX,
        Math.max(Cnvs.Frames.frameState.MIN, Cnvs.Frames.frameState.scale)
      );

      Cnvs.Frames.frameState.startDist = newDist;

      const midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
      const midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;

      // delta movement
      const dx = midX - Cnvs.Frames.frameState.startMidX;
      const dy = midY - Cnvs.Frames.frameState.startMidY;

      // accumulate translation
      Cnvs.Frames.frameState.translateX += dx;
      Cnvs.Frames.frameState.translateY += dy;

      // update start midpoint
      Cnvs.Frames.frameState.startMidX = midX;
      Cnvs.Frames.frameState.startMidY = midY;

      if (!Cnvs.Frames._raf) {
        Cnvs.Frames._raf = requestAnimationFrame(() => {
          Cnvs.Frames.setTransform(frame);
          Cnvs.Frames._raf = null;
        });
      }
    },

    touchEnd(e) {
      const frame = Cnvs.Frames.frameState.activeFrame;
      if (!frame) return;
      
      // Use setTimeout to ensure DOM is ready
      requestAnimationFrame(() => {
        void frame.offsetWidth;
        
        // Reset state
        Cnvs.Frames.frameState.scale = 1;
        Cnvs.Frames.frameState.originX = 50;
        Cnvs.Frames.frameState.originY = 50;
        Cnvs.Frames.frameState.startDist = 0;
        Cnvs.Frames.frameState.translateX = 0;
        Cnvs.Frames.frameState.translateY = 0;

        frame.style.transition = "transform 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
        Cnvs.Frames.setTransform(frame);

        setTimeout(() => {
          frame.style.transition = "";
          void frame.offsetWidth;
        }, 200);

        Cnvs.Frames.frameState.activeFrame = null;

        setTimeout(() => {
          frame.classList.remove("no-transition");
          frame.classList.remove("zooming");
          frame.closest(".frame_container").classList.remove("zooming");
          S$Q("body").classList.remove("body-lock");
          S$Q(".dp_wrapper")?.style.removeProperty("z-index");

          const finfo = frame.closest(".frame_container")?.querySelector(".finfo");
          finfo?.style.removeProperty("display");

          S$Q(".frames_swiper")?.style.removeProperty("overflow");

          S$Q(".dp_fub.mo")?.style.removeProperty("display");

          const dpEb = frame.querySelector(".dp_eb");
          dpEb?.style.removeProperty("display");

          const container = frame.closest(".frame_container");
          container?.style.removeProperty("z-index");

          
          const el = S$Q(".dp_main");
          if (el) {
            el.style.removeProperty("z-index");
          }
        }, 50);

        document.removeEventListener("touchmove", Cnvs.Frames.touchMove);
        document.removeEventListener("touchend", Cnvs.Frames.touchEnd);
        document.removeEventListener("touchcancel", Cnvs.Frames.touchEnd);
      });
    },

    updateThumbMask(slider) {
        const rect = slider.getBoundingClientRect();
        const min = parseFloat(slider.min) || 0;
        const max = parseFloat(slider.max) || 100;
        const val = parseFloat(slider.value);
        const percent = (val - min) / (max - min);
        const thumbWidth = 20;
        const thumbBorder = 0;
        const thumbSize = thumbWidth + (thumbBorder * 2);

        // Calculate accurate thumb center position
        const trackWidth = rect.width;
        const thumbHalfSize = thumbSize / 2;
        
        // Account for thumb size in position calculation
        const thumbX = rect.left + thumbHalfSize + (percent * (trackWidth - thumbSize));
        const thumbY = rect.top + rect.height / 2;

        const root = document.documentElement;
        root.style.setProperty('--thumb-center-x', `${thumbX}px`);
        root.style.setProperty('--thumb-center-y', `${thumbY}px`);
        root.style.setProperty('--thumb-radius', `${thumbHalfSize}px`);
    },

    openPopupAnimation() {
      const pu = Cnvs.Popup.current;
      const popupFrame = pu.ceF;
      const targetFrame = pu.cuF;
      
      popupFrame.classList.remove('is-animating');
      
      // Get FIRST position (original frame)
      const firstRect = targetFrame.getBoundingClientRect();

      // Make popup frame invisible temporarily
      popupFrame.style.opacity = "0";
      popupFrame.style.transition = "none";
      popupFrame.style.transform = "none";
      popupFrame.style.pointerEvents = "none"
      
      // Force reflow
      popupFrame.offsetHeight;
      
      // Force DOM update
      requestAnimationFrame(() => {
        // Get LAST position
        const lastRect = popupFrame.getBoundingClientRect();

        // Calculate differences
        const deltaX = firstRect.left - lastRect.left;
        const deltaY = firstRect.top - lastRect.top;
        const deltaScaleX = firstRect.width / lastRect.width;
        const deltaScaleY = firstRect.height / lastRect.height;
        
        popupFrame.style.transformOrigin = "top left";
        popupFrame.style.transform = `
          translate(${deltaX}px, ${deltaY}px)
          scale(${deltaScaleX}, ${deltaScaleY})
        `;
        popupFrame.style.opacity = "1";

        popupFrame.offsetHeight;
        
        popupFrame.style.transition = "";
        popupFrame.classList.add('is-animating');
        
        popupFrame.style.transform = "translate(0px, 0px) scale(1, 1)";
        
        S$Q(".dp_epu-box").classList.add("show");
        S$Q(".dp_epu").classList.add("show");
      });
      
      // Handle transition end
      const onTransitionEnd = () => {
        popupFrame.removeEventListener('transitionend', onTransitionEnd);
        popupFrame.classList.remove('is-animating');
        popupFrame.style.removeProperty("transform");
        popupFrame.style.removeProperty("transform-origin");
        popupFrame.style.removeProperty("pointer-events");
        S$Q(".dp_epu-box").classList.add("epu-ready");
      };
      
      popupFrame.addEventListener('transitionend', onTransitionEnd, { once: true });

      setTimeout(() => {
        S$Q(".dp_epu-box").classList.add("epu-ready");
      }, 500);
    },

    createCloneForAnimation() {
        const pu = Cnvs.Popup.current;
        const targetFrame = pu.cuF;
        const clone = targetFrame.cloneNode(true);
        clone.classList.add("clone-f");
        const rect = targetFrame.getBoundingClientRect();

        clone.style.position = "fixed";
        clone.style.left = rect.left + "px";
        clone.style.top = rect.top + "px";
        clone.style.width = rect.width + "px";
        clone.style.height = rect.height + "px";
        clone.style.margin = "0";
        clone.style.transform = "none";
        clone.style.zIndex = "9999";

        document.body.appendChild(clone);

        // Hide original
        targetFrame.style.opacity = "0";
        targetFrame.style.visibility = "hidden";
    },

    closePopupAnimation(close = false) {
        const pu = Cnvs.Popup.current;
        const popupFrame = pu.ceF;
        const targetFrame = pu.cuF;
        
        if (!popupFrame || !targetFrame) return;

        S$Q(".dp_epu-box").classList.remove("epu-ready");
        
        const MAX_TIME = 400;
        const useReplica = close === true;
        
        // Determine which element to animate
        const sourceElement = useReplica ? targetFrame.cloneNode(true) : popupFrame;
        const isReplica = useReplica;
        
        if (isReplica) {
            // Setup replica
            sourceElement.classList.add('frame-replica');
            Object.assign(sourceElement.style, {
                position: 'fixed',
                margin: '0',
                zIndex: '9999',
                pointerEvents: 'none',
                transform: 'none',
                transition: 'none'
            });
            
            // Position replica exactly where popup is
            const popupRect = popupFrame.getBoundingClientRect();
            sourceElement.style.top = popupRect.top + 'px';
            sourceElement.style.left = popupRect.left + 'px';
            
            // Hide original popup
            popupFrame.style.opacity = '0';
            popupFrame.style.pointerEvents = 'none';
            
            // Add replica to DOM
            document.body.appendChild(sourceElement);
        } else {
            // Setup original popup for animation
            sourceElement.style.transition = "none";
            sourceElement.style.transformOrigin = "top left";
            sourceElement.style.transform = "translate(0px, 0px) scale(1, 1)";
            sourceElement.offsetHeight;
            sourceElement.style.transition = "";
            sourceElement.classList.add('is-animating');
        }
        
        // Get positions and calculate transforms
        const fromRect = isReplica ? popupFrame.getBoundingClientRect() : popupFrame.getBoundingClientRect();
        const toRect = targetFrame.getBoundingClientRect();
        
        const deltaX = toRect.left - fromRect.left;
        const deltaY = toRect.top - fromRect.top;
        let deltaScaleX = toRect.width / fromRect.width;
        let deltaScaleY = toRect.height / fromRect.height;
        
        // Force reflow for replica
        if (isReplica) {
            sourceElement.offsetHeight;
            sourceElement.style.transition = 'all 0.3s ease-in-out';
            sourceElement.style.transformOrigin = 'top left';
            deltaScaleX = 1;
            deltaScaleY = 1;
        }
        
        // Apply transform
        sourceElement.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${deltaScaleX}, ${deltaScaleY})`;
        
        S$Q(".dp_epu-box").style.backgroundColor = "rgba(255, 255, 255, 0)";
        if (this.dType === "M") {
            S$Q(".dp_epu").style.backgroundColor = "#11111190";
        }
        
        S$Q(".dp_epu-box").classList.remove("epu-ready");
        S$Q(".dp_epu").classList.remove("show");
        
        // Remove any existing clone
        const existingClone = document.querySelector(".frame.clone-f");
        if (existingClone) existingClone.remove();
        
        // Setup cleanup
        let finished = false;
        
        const cleanup = () => {
            if (finished) return;
            finished = true;
            
            if (isReplica) {
                if (sourceElement?.parentNode) {
                    sourceElement.remove();
                }
                // Reset popup styles
                popupFrame.style.removeProperty('opacity');
                popupFrame.style.removeProperty('pointer-events');
            } else {
                popupFrame.removeEventListener("transitionend", onEnd);
                popupFrame.classList.remove('is-animating');
            }
            
            // Common cleanup
            S$Q(".dp_epu-box").style.removeProperty("background-color");
            S$Q(".dp_epu").style.removeProperty("background-color");
            S$Q(".dp_epu").style.removeProperty("display");
            S$Q(".dp_epu-box").style.removeProperty("overflow");
            S$Q(".dp_epu").classList.remove("show");
            S$Q(".dp_epu-box").classList.remove("show");
            S$Q(".dp_epu").style.removeProperty("opacity");
            S$Q(".dp_epu-body").innerHTML = "";
            
            // Show target frame
            targetFrame.style.opacity = "1";
            targetFrame.style.removeProperty("visibility");
        };
        
        const onEnd = (e) => {
            if (e.target !== sourceElement) return;
            if (!isReplica && e.propertyName !== "transform") return;
            cleanup();
        };
        
        sourceElement.addEventListener("transitionend", onEnd, {once: true});
        setTimeout(cleanup, MAX_TIME);
        Cnvs.State.closePopup();
    },
  };

  // Mobile edit function
  Cnvs.Frames.mobileEditFrame = function (e) {
    return Cnvs.Frames.editFrame(e);
  };
})(window);
